import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { cloneDeep, isEmpty } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { withRouter  } from 'react-router-dom';
import moment from "moment";
import 'moment/locale/ru';
import { styles } from "../../../../containers/goods/styles";
import Loader from "../../../utils/Loader";
import { fetchFilials } from "../../../../action/handbook";
import ErrorContainer from "../../../utils/ErrorContainer";
import { formatNumberWithSpaces, parseNumToFixed, roundToFixed } from "../../../../utils/common";
import { fetchSettings } from "../../../../action/app";
import { autoCreateStaffData, fetchStaffs, fetchWageFundData, saveWageFundData } from "../../../../action/wageFund";
import { postsIds, roleId, urls } from "../../../../constants/app";
import swal from 'sweetalert';
import Input from '../../../utils/Input';
import Select from 'react-select';
import PrizeTable from "./PrizeTable";
import ResultTable from "./ResultTable";
// import PrizeRevenueTable from "./PrizeRevenueTable";
import DateInput from "../../../utils/DateInput";
import ContextMenu from "../../../utils/ContextMenu";
import ReactTooltip from "react-tooltip";
import request from "../../../../action/utils/request";

const months = [ 'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь' ];

const stylesTable = {
    sm: {
        width: '75px',
        color: '#000',
        textAlign: 'center',
        padding: '5px',
        overflow: 'auto',
    },
    md: {
        width: '145px',
        color: '#000',
        textAlign: 'center',
        padding: '5px',
        overflow: 'auto',
    },
    lg: {
        width: '225px',
        color: '#000',
        textAlign: 'center',
        padding: '5px',
        overflow: 'auto',
    },
    outline: {
        outline: '1px solid #000'
    },
    borderLeft: {
        borderLeft: '1px solid #000',
    },
    borderRight: {
        borderRight: '1px solid #000',
    },
    textStart: {
        textAlign: 'start'
    },
    input: {
        outline: 'none',
        border: 'none',
        width: '100%',
        backgroundColor: '#fff0',
        textAlign: 'center',
    }
}

const StaffNameCell = ({
  value,
  index,
  disabled,
  disabledDelete,
  onNameChange,
  onDelete,
  showDelete,
  stylesTable,
}) => {
  const inputRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const checkOverflow = useCallback(() => {
    if (inputRef.current) {
      const el = inputRef.current;
      setIsOverflowing(el.scrollWidth > el.clientWidth);
    }
  }, []);

  useEffect(() => {
    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    return () => window.removeEventListener('resize', checkOverflow);
  }, [checkOverflow]);

  useEffect(() => {
    const input = inputRef.current;
    if (!input) return;

    const handleWheel = (e) => {
      e.preventDefault();
    };

    input.addEventListener('wheel', handleWheel, { passive: false });

    return () => {
      input.removeEventListener('wheel', handleWheel);
    };
  }, []);

  useEffect(() => {
    checkOverflow();
  }, [value, checkOverflow]);

  const tooltipId = `staff-name-tip-${index}`;

  return (
    <td
      style={{
        ...stylesTable.lg,
        ...stylesTable.textStart,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'relative',
        overflow: 'hidden',
      }}
      className="kt-datatable__cell"
    >
      <input
        ref={inputRef}
        disabled={disabled}
        onFocus={(e) => e.target.select()}
        style={{
          ...stylesTable.input,
          ...stylesTable.textStart,
          width: '80%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
        defaultValue={value}
        onChange={(e) => onNameChange(e.target.value, 'name', index)}
        data-tip={isOverflowing ? value : ''}
        data-for={tooltipId}
      />
      {showDelete && (
        <button disabled={disabledDelete} onClick={() => onDelete(index, value)} className="button_order_table">
          <i className="kt-nav__link-icon flaticon2-trash order_table" />
        </button>
      )}
      {isOverflowing && (
        <ReactTooltip
        id={tooltipId}
        effect="solid"
        place="right"
        delayShow={100}
        delayHide={200}
        backgroundColor="#5867dd"
        className="wageFund-tooltip"
        positionStrategy="fixed"
        boundary="window"
        scrollHide={true}
        />
      )}
    </td>
  );
};

function WageFundTable({ history, match }) {
    const initData = useSelector(state => state.wageFund.revenue);
    const staffData = useSelector(state => state.wageFund.revenuesStaff);
    const staff = useSelector(state => state.wageFund.staff);
    const points = useSelector(state => state.handbook.filials);
    const pointsCount = useSelector(state => state.handbook.count.filials);
    const loadingPoints = useSelector(state => state.loaders.filials);
    const loadingWages = useSelector(state => state.loaders.wageFund);
    const loadingStaff = useSelector(state => state.loaders.staff);
    const loading = loadingPoints || loadingWages || loadingStaff;
    const settings = useSelector(state => state.settings.init);
    const user = useSelector(state => state.user.info);
    
    const [data, setData] = useState({revenue: cloneDeep(initData), revenuesStaff: cloneDeep(staffData)});
    const [modal, setModal] = useState(null);
    const [renderRevenueStaff, setRenderRevenueStaff] = useState('hours');
    const [newStaff, setNewStaff] = useState({});
    const [prizes, setPrizes] = useState({ percent: null, prizeRevenue: null, sumRevenuePrize: null });
    const [openPrizesColumns, setOpenPrizesColumns] = useState(true);
    const [period, setPeriod] = useState({ start: { date: null, index: null }, end: { date: null, index: null } });
    const [pressTimer, setPressTimer] = useState(null);

    const date = moment(data.revenue.startOfMonthDate);
    const now = moment();
    const yearNow = now.year();
    const monthNow = now.month();
    const yearDate = date.year();
    const monthDate = date.month();

    const isPlan = (yearNow < yearDate) || (yearNow === yearDate && monthNow < monthDate);
    const [changed, setChanged] = useState(isPlan ? 'plan' : 'result');

    const dispatch = useDispatch();

    const modalRef = useRef(null);
    const contextMenuRef = useRef(null);
    const containerRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modal && modalRef.current && !modalRef.current.contains(event.target)) {
                const datePickerPortal = document.getElementById('modal-picker');
                if (datePickerPortal && datePickerPortal.contains(event.target)) return;
                if (event.target.closest('.css-1n7v3ny-option')) return;
                if (modal.type === 'prizes') setPrizes({ percent: null, prizeRevenue: null, sumRevenuePrize: null });
                setModal(null);
            }
        };
    
        if (modal) {
            document.addEventListener('mousedown', handleClickOutside);
            return () => document.removeEventListener('mousedown', handleClickOutside);
        }
    }, [modal]);

    useEffect(() => {
        if (modal) {
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = '15px';
        } else {
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        }
        
        return () => {
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        };
    }, [modal]);

    useEffect(() => {
        const getData = async (id) => {
            const response = await dispatch(fetchWageFundData({id}));
            if (response && response.revenue && response.revenue.id) {
                if (response.revenue.pointId) await dispatch(fetchStaffs({ pointId: response.revenue.pointId }, false, true, true))
                return setData(cloneDeep(response));
            }
            return history.goBack();
        }
        if (!data || isEmpty(data.revenue)) {
            const id = match.params.id;
            if (!id) return history.goBack();
            getData(id);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [match.params.id, dispatch, history]);

    useEffect(() => {
        if (user.role.id === roleId.cashier) {
            const date = moment().startOf('day').format('DD.MM.YYYY');
            const updated = { ...data}
            updated.revenuesStaff = updated.revenuesStaff.map((revenueStaff) => {
                revenueStaff.revenues = revenueStaff.revenues.map((revenue, index) => {
                    const currentDate = moment(data.revenue.startOfMonthDate).add(index, 'days').startOf('day').format('DD.MM.YYYY');
                    if (revenue && revenue.sum && date === currentDate && !revenue.sum.result && revenue.sum.result !== 0) {
                        revenue.sum.result = 0;
                        revenueStaff.isChange = true;
                    }

                    return revenue;
                });
                
                return revenueStaff;
            });

            setData(updated);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.revenue, user.role.id])

    useEffect(() => {
        isEmpty(settings) && dispatch(fetchSettings());
    }, [dispatch, settings]);

    useEffect(() => {
        const getData = async () => { await dispatch(fetchFilials(null, true)) }
        if (isEmpty(points) || points.length < pointsCount) getData();
    }, [points, pointsCount, dispatch]);

    useEffect(() => {
        const autoCreate = async () => {
            if (!isEmpty(data) && !isEmpty(data.revenue)) {
                const usedStaffIds = (data.revenuesStaff || []).map((item) => item.staffId).filter((id) => id);
                const unusedStaff = staff.filter((item) => {
                    if (item.pointId !== data.revenue.pointId) return false;
                    if (usedStaffIds.includes(item.id)) return false;
                    if (moment(item.created_at).month() > moment(data.revenue.startOfMonthDate).month()) return false;
                    return true;
                });

                if (isEmpty(unusedStaff)) return;
    
                const created = await dispatch(autoCreateStaffData(unusedStaff, data.revenue.id, data.revenue.startOfMonthDate));
                if (created && Array.isArray(created)) {
                    const updated = {...data};
                    const resultStaff = [...(updated.revenuesStaff || []), ...created];
                    updated.revenuesStaff = resultStaff;
                    setData(updated);
                }
            }
        }

        if (!loading) autoCreate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.revenue, dispatch, staff]);

    useEffect(() => {
        if (!data || !data.revenuesStaff || !staff) return;
        
        let changed = false;
        const updatedRevenuesStaff = data.revenuesStaff.map(item => {
            if (item.staffId) {
                const entity = staff.find((s) => s.id === item.staffId);
                if (entity && entity.name) {
                    changed = true;
                    return { ...item, actualName: entity.name };
                }
            }
            return item;
        });
        
        if (changed) setData(prev => ({ ...prev, revenuesStaff: updatedRevenuesStaff }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [staff]);

    const columnsCount = (data && data.revenue && data.revenue.revenues) ? data.revenue.revenues.length || 0 : 0;

    const daysOfWeek = useMemo(() => {
        if (!data.revenue.startOfMonthDate) return [];
        const startDate = moment(data.revenue.startOfMonthDate);
        if (!startDate.isValid()) return [];
        return Array.from({ length: columnsCount }, (_, i) =>
            startDate.clone().add(i, 'day').locale('ru').format('dd')
        );
    }, [data.revenue, columnsCount]);
    
    const weekendsDaysIndexes = useMemo(() => {
        if (!data.revenue.startOfMonthDate) return [];
        const startDate = moment(data.revenue.startOfMonthDate);
        if (!startDate.isValid()) return [];
    
        return Array.from({ length: columnsCount }, (_, index) => index)
            .filter((index) => {
                const dayOfWeek = startDate.clone().add(index, 'day').day();
                return dayOfWeek === 5 || dayOfWeek === 6 || dayOfWeek === 0;
            });
    }, [data.revenue, columnsCount]);

    const colWidths = useMemo(() => {
        let widths;

        if (user.role.id !== roleId.cashier) {
            if (openPrizesColumns) {
                widths = [225, 75, 145, 145];
            } else {
                widths = [225, 75];
            }
        } else {
            widths = [225]
        }
        
        for (let i = 0; i < columnsCount; i++) {
            if (period.start.index && i < period.start.index) continue;
            if (period.end.index && i > period.end.index) continue;

            if (i === 14 && period.end.index !== 14) {
                if (user.role.id !== roleId.cashier) {
                    if (openPrizesColumns) {
                        widths.push(75, 75, 145, 225, 75, 145, 145);
                    } else {
                        widths.push(75, 75, 145, 225, 75);
                    }
                } else {
                    widths.push(75, 75, 225);
                }
            } else {
                widths.push(75);
            }
        }
        if (user.role.id !== roleId.cashier) {
            widths.push(75, 145, 75, 145);
        } else {
            widths.push(75, 75);
        }
        return widths;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [columnsCount, openPrizesColumns, period]);

    const getIsChangedData = useCallback(() => {
        if (data.revenue.isChange) return true;
        const changedStaff = (data.revenuesStaff || []).filter((item) => item.isChange || item.isChangeData);
        return changedStaff && changedStaff.length > 0;
    }, [data.revenue.isChange, data.revenuesStaff]);

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            if (getIsChangedData()) {
                e.preventDefault();
                e.returnValue = '';
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [getIsChangedData]);

    useEffect(() => {
        const unblock = history.block(() => {
            if (getIsChangedData()) {
                const answer = window.confirm('Вы покидаете страницу не сохранив данные. Внесенные данные не будут сохранены.');
                if (answer) {
                    unblock();
                    return true;
                } 
                return false;
            }
            return true;
        });
      
        return () => unblock();
    }, [history, getIsChangedData]);

    const isNotNumber = (value) => {
        if (value === null || value === undefined || typeof value === 'boolean') return true;
        if (typeof value === 'number') return isNaN(value) || !isFinite(value);

        if (typeof value === 'string') {
            const trimmed = value.trim();
            if (trimmed === '') return true;
            const num = Number(trimmed);
            return isNaN(num);
        }
    
        return true;
    }

    const renderItemSum = (item, field, force = false) => {
        if (!item || !item.sum) return { color: 'red', sum: 'NaN'};
        if (isNotNumber(item.sum.result) && field === 'result') return { color: 'red', sum: 0 };
        if (!isNotNumber(item.sum.result) && ((!field && changed === 'result') || field === 'result')) {
            let color = '#000';
            if (item.sum.plan !== null && item.sum.result > (item.sum.plan || 0)) color = 'green';
            if (item.sum.plan && item.sum.result < item.sum.plan) color = 'red';
            return { color, sum: parseNumToFixed(item.sum.result) };
        }

        if (!force && user.role.id === roleId.cashier) return { color: '#000', sum: parseNumToFixed(item.sum.result) }
        return { color: '#000', sum: parseNumToFixed(item.sum.plan) };
    }

    const calculateTotal = (items, separation) => {
        if (!items || items.length === 0) return  { first: { result: '-' }, second: { result: '-' }, total: { result: '-' } };
        const result = items.reduce((acc, item, index) => {
            if (period.start.index && index < period.start.index) return acc;
            if (period.end.index && index > period.end.index) return acc;
            if (!item || !item.sum) return acc;
            const sum = !isNotNumber(item.sum.result) ? parseNumToFixed(item.sum.result) : (!separation && user.role.id !== roleId.cashier) ? parseNumToFixed(item.sum.plan) || 0 : 0;
            if (!isNotNumber(item.sum.plan)) acc.total.plan += parseNumToFixed(item.sum.plan);
            if (!isNotNumber(sum)) acc.total.result += sum;
            if (index <= 14) {
                if (!isNotNumber(item.sum.plan)) acc.first.plan += parseNumToFixed(item.sum.plan);
                if (!isNotNumber(sum)) acc.first.result += sum;    
            } else {
                if (!isNotNumber(item.sum.plan)) acc.second.plan += parseNumToFixed(item.sum.plan);
                if (!isNotNumber(sum)) acc.second.result += sum;
            }
            return acc;
        }, { first: { result: null, plan: 0, color: null }, second: { result: null, plan: 0, color: null }, total: { result: null, plan: 0, color: null } });

        const getColor = (data) => {
            if (isNotNumber(data.result) || data.result === '-') return null;
            if (data.result > (data.plan || 0)) return '#B7E1CD';
            if (data.result < data.plan) return '#F4CCCC';
            return null;
        }

        if (result) {
            if (result.first) result.first.color = getColor(result.first);
            if (result.second) result.second.color = getColor(result.second);
            if (result.total) result.total.color = getColor(result.total);
        }
        return result;
    }

    const totalData = calculateTotal(data.revenue.revenues, true);

    const renderDateCells = () => {
        return Array.from({ length: columnsCount }, (_, index) => {
            if (period.start.index && index < period.start.index) return null;
            if (period.end.index && index > period.end.index) return null;

            const styles = weekendsDaysIndexes.includes(index) ? { ...stylesTable.sm, backgroundColor: '#ffefd8' } : stylesTable.sm;
            if (index !== 14 || (index === 14 && period.end.index === 14)) {
                return (
                    <td key={`num-${index}`} style={{ ...styles, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                        {index + 1}
                    </td>
                );
            }
            return (
                <React.Fragment key={`num-group-${index}`}>
                    <td style={{ ...styles, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                        {index + 1}
                    </td>
                    <td style={user.role.id !== roleId.cashier ? { ...stylesTable.sm, ...stylesTable.borderLeft } : { ...stylesTable.sm, ...stylesTable.borderLeft, ...stylesTable.borderRight }} className="kt-datatable__cell">
                        Итого
                    </td>
                    {user.role.id !== roleId.cashier && <td style={{ ...stylesTable.md, ...stylesTable.borderLeft, ...stylesTable.borderRight }} className="kt-datatable__cell">
                        Итого
                    </td>}
                    <td style={stylesTable.lg} className="kt-datatable__cell" />
                    {user.role.id !== roleId.cashier && 
                    <>
                    <td style={stylesTable.sm} className="kt-datatable__cell" />
                    {openPrizesColumns &&
                        <>
                        <td style={stylesTable.md} className="kt-datatable__cell" />
                        <td style={stylesTable.md} className="kt-datatable__cell" />
                        </>
                    }
                    </>
                    }
                </React.Fragment>
            );
        });
    };

    const renderDayCells = () => {
        return Array.from({ length: columnsCount }, (_, index) => {
            if (period.start.index && index < period.start.index) return null;
            if (period.end.index && index > period.end.index) return null;

            const day = daysOfWeek[index];
            const styles = weekendsDaysIndexes.includes(index) ? { ...stylesTable.sm, backgroundColor: '#ffefd8' } : stylesTable.sm;

            if (index !== 14 || (index === 14 && period.end.index === 14)) {
                return (
                    <td key={`day-${index}`} style={ index + 1 < columnsCount ? { ...styles, ...stylesTable.borderLeft } : { ...styles, ...stylesTable.sm, ...stylesTable.borderLeft, ...stylesTable.borderRight}} className="kt-datatable__cell">
                        {day}
                    </td>
                );
            }
            return (
                <React.Fragment key={`day-group-${index}`}>
                    <td style={{ ...styles, ...stylesTable.borderLeft, ...stylesTable.borderRight }} className="kt-datatable__cell">
                        {day}
                    </td>
                    <td style={stylesTable.sm} className="kt-datatable__cell" />
                    {user.role.id !== roleId.cashier && <td style={stylesTable.md} className="kt-datatable__cell" />}
                    <td style={stylesTable.lg} className="kt-datatable__cell" />
                    {user.role.id !== roleId.cashier && 
                    <>
                    <td style={stylesTable.sm} className="kt-datatable__cell" />
                    {openPrizesColumns &&
                        <>
                        <td style={stylesTable.md} className="kt-datatable__cell" />
                        <td style={stylesTable.md} className="kt-datatable__cell" />
                        </>
                    }
                    </>
                    }
                </React.Fragment>
            );
        });
    };

    const calculatePercent = (value1, value2) => {
        if (!value1 || !value2) return 0;
        return parseNumToFixed((value1 / value2) * 100);
    }

    const renderPercentCells = () => {
        return data.revenue.revenues.map((item, index) => {
            if (period.start.index && index < period.start.index) return null;
            if (period.end.index && index > period.end.index) return null;

            const renderDataPlan = renderItemSum(item, 'plan', true);
            const renderDataResult = renderItemSum(item, 'result', true);
            const percent = calculatePercent((renderDataResult.sum || 0), (renderDataPlan.sum || 0));
            
            const styles = weekendsDaysIndexes.includes(index) ? { ...stylesTable.sm, backgroundColor: '#ffefd8' } : stylesTable.sm;

            if (index !== 14 || (index === 14 && period.end.index === 14)) {
                return (
                    <td key={`revenue-${index}`} style={{ ...styles, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                        <span>
                            {formatNumberWithSpaces(percent)}%
                        </span>
                    </td>
                );
            }
            return (
                <React.Fragment key={`revenue-group-${index}`}>
                    <td style={{ ...styles, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                        <span>
                            {formatNumberWithSpaces(percent)}%
                        </span>
                    </td>
                    <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft, ...stylesTable.borderRight }} className="kt-datatable__cell">
                        {formatNumberWithSpaces(calculatePercent(totalData.first.result, totalData.first.plan))}%
                    </td>
                    {user.role.id !== roleId.cashier && <td style={{ ...stylesTable.md, ...stylesTable.borderLeft, ...stylesTable.borderRight }} className="kt-datatable__cell"/> }
                    <td style={stylesTable.lg} className="kt-datatable__cell" />
                    {user.role.id !== roleId.cashier && 
                    <>
                    <td style={stylesTable.sm} className="kt-datatable__cell" />
                    {openPrizesColumns &&
                        <>
                        <td style={stylesTable.md} className="kt-datatable__cell" />
                        <td style={stylesTable.md} className="kt-datatable__cell" />
                        </>
                    }
                    </>
                    }
                </React.Fragment>
            );
        });
    }

    const renderRevenueCells = (field) => {
        return data.revenue.revenues.map((item, index) => {
            if (period.start.index && index < period.start.index) return null;
            if (period.end.index && index > period.end.index) return null;

            const renderData = renderItemSum(item, field);
            const styles = weekendsDaysIndexes.includes(index) ? { ...stylesTable.sm, backgroundColor: '#ffefd8' } : stylesTable.sm;

            if (index !== 14 || (index === 14 && period.end.index === 14)) {
                return (
                    <td key={`revenue-${index}`} style={{ ...styles, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                        <span style={ field === 'result' ? { color: renderData.color } : {}}>
                            {formatNumberWithSpaces(roundToFixed(renderData.sum, 0))}
                        </span>
                    </td>
                );
            }
            return (
                <React.Fragment key={`revenue-group-${index}`}>
                    <td style={{ ...styles, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                        <span style={ field === 'result' ? { color: renderData.color } : {}}>
                            {formatNumberWithSpaces(roundToFixed(renderData.sum, 0))}
                        </span>
                    </td>
                    <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell" />
                    {user.role.id !== roleId.cashier && <td style={{ ...stylesTable.md, ...stylesTable.borderLeft, ...stylesTable.borderRight, backgroundColor: field === 'result' ? totalData.first.color : null }} className="kt-datatable__cell">
                        {formatNumberWithSpaces(roundToFixed(totalData.first[field], 0))}
                    </td>}
                    <td style={stylesTable.lg} className="kt-datatable__cell" />
                    {user.role.id !== roleId.cashier && 
                    <>
                    <td style={stylesTable.sm} className="kt-datatable__cell" />
                    {openPrizesColumns &&
                        <>
                        <td style={stylesTable.md} className="kt-datatable__cell" />
                        <td style={stylesTable.md} className="kt-datatable__cell" />
                        </>
                    }
                    </>
                    }
                </React.Fragment>
            );
        });
    };

    const renderPointLabel = (point) => {
        if (!point) return 'Филиал не определен';
        const cityName = point.city ? point.city.name : 'Город не указан';
        return `${cityName}, ${point.street || 'Улица не указана'} ${point.house || ''}`
    };
    
    const dateTitle = `${months[date.month()]} ${date.year()}`
    const point = points.find((p) => p.id === data.revenue.pointId);
    const pointName = renderPointLabel(point);

    const getBlock = (type) => {
        if (user && [roleId.admin, roleId.operationDirector, roleId.regionalDirector].includes(user.role.id)) return false;
        if (user.role.id === roleId.cashier && moment().isBefore(moment(data.revenue.startOfMonthDate))) return true;
        let block = 3;
        if (point && !isNotNumber(point.blockWageFund)) block = point.blockWageFund || 0;
        if (type === 'first') {
            const endDate = moment(data.revenue.startOfMonthDate).date(15).add(block, 'days').endOf('day');
            if (moment().isAfter(endDate)) return true;
            return false;
        } else {
            const endDate = moment(data.revenue.startOfMonthDate).endOf('month').add(block, 'days').endOf('day');
            if (moment().isAfter(endDate)) return true;
            return false;
        }
    }

    const isBlockSecond = getBlock('second');
    const isBlockFirst = isBlockSecond ? true : getBlock('first');

    if (loading) return(
        <div className='kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid'>
            <div style={styles.tableLoading}><Loader text='Загружаю данные'/></div>
        </div>
    );

    const onRefresh = async (ignore) => {
        const id = match.params.id;
        let refresh = true;
        
        if (!ignore && getIsChangedData()) {
            refresh = false;
            await swal({
                title: "Вы обновляете страницу не сохранив данные",
                text: 'Внесенные данные не будут сохранены',
                icon: "warning",
                dangerMode: true,
                buttons: ["Отмена", "Обновить страницу без сохранения"],
            }).then((accept) => {
                if (accept) refresh = true;
            });
        }

        if (refresh) {
            if (!id) return history.goBack();
            const response = await dispatch(fetchWageFundData({id}));
            if (response && response.revenue && response.revenue.id) {
                await dispatch(fetchStaffs({ pointId: response.revenue.pointId }, false, true, true));
                return setData(cloneDeep(response));
            }
            return history.goBack();
        }
    }

    const handleBack = () => {
        if (getIsChangedData()) return swal({
            title: "Вы покидаете страницу не сохранив данные",
            text: 'Внесенные данные не будут сохранены',
            icon: "warning",
            dangerMode: true,
            buttons: ["Отмена", "Покинуть страницу без сохранения"],
        }).then((accept) => {
            if (accept) history.goBack();
        });
        history.goBack();
    }

    const hendleChangeRenderStaff = () => {
        if (renderRevenueStaff === 'hours') return openModal('choiceRenderRevenue');
        return setRenderRevenueStaff('hours');
    }

    const onChangeEdit = (value) => {
        if (![roleId.admin, roleId.operationDirector, roleId.regionalDirector].includes(user.role.id)) return;
        setChanged(value);
    }

    const renderSubHeader = () => {
        return (
            <div className="kt-subheader not-mt kt-grid__item" style={{ position: 'fixed', left: '50px', zIndex: 11, width: '100%', maxWidth: '98vw' }}>
                <div className="kt-container  kt-container--fluid">
                    <div className="kt-subheader__main">
                        <h3 className="kt-subheader__title">Табель</h3>
                        <span className="kt-subheader__separator kt-subheader__separator--v"/>
                        <h3 className="kt-subheader__title">{pointName}</h3>
                        <span className="kt-subheader__separator kt-subheader__separator--v"/>
                        <h3 className="kt-subheader__title">{dateTitle}</h3>
                        <button onClick={() => onRefresh(false)} className="btn btn-secondary btn-icon">
                            <i className="la la-refresh"/>
                        </button>
                    </div>
                    <div className="d-flex" style={{ alignItems: 'center' }}>
                        <button
                            onClick={handleBack}
                            className="btn btn-secondary"
                            style={{ marginRight: '15px' }}>
                            <i className="la la-arrow-left"></i> Назад
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    const renderButtonsHead = () => {
        return (
            <div className="kt-portlet" style={{ marginTop: '70px', marginBottom: '10px' }}>
                <div className="kt-portlet__body kt-portlet__body--fit" style={{ padding: '10px', gap: '10px' }}>
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        {![roleId.cashier].includes(user.role.id) &&
                            <>
                            <button onClick={() => openModal('history')} className="btn btn-secondary">
                                История изменений
                            </button>
                            <button onClick={() => openModal('period')} className="btn btn-secondary">
                                Выбрать период
                            </button>
                            <button onClick={hendleChangeRenderStaff} className="btn btn-secondary">
                                {renderRevenueStaff === 'hours' ? 'Пересчитать часы сотрудников в руб.' : 'Пересчитать руб. сотрудников в часы'}
                            </button>
                            <button title='Добавить сотрудника' onClick={() => openModal('postChoice')} className="btn btn-icon btn-icon-lg btn-secondary">
                                <i className="la la-user-plus"/>
                            </button>
                            <button 
                            title='Настройки'
                            onClick={() => {
                                if (isEmpty(data) || isEmpty(data.revenue)) return;
                                openModal('settings', { normalShift: data.revenue.normalShift || 13, revenueRatio: data.revenue.revenueRatio || 0, percentsPosts: {...data.revenue.percentsPosts} })
                            }}
                            className="btn btn-icon btn-icon-lg btn-secondary">
                                <i className="flaticon2-gear"/>
                            </button>
                            <button title='Премия' className="btn btn-icon btn-icon-lg btn-secondary" style={{ position: 'relative' }} onClick={() => openModal('handlePrizes')}>
                                <span style={{ position: 'absolute', top: '-3px', left: '3px', fontSize: '16px', color: '#0abb87'}}> + </span>
                                <i className="la la-money" />
                            </button>
                            <button title='Депремирования' className="btn btn-icon btn-icon-lg btn-secondary" style={{ position: 'relative' }} onClick={() => openModal('handleDepremation')}>
                                <span style={{ position: 'absolute', top: '-10px', left: '3px', fontSize: '24px', color: 'red'}}> - </span>
                                <i className="la la-money" />
                            </button>
                            </>
                        }
                    </div>
                    {[roleId.admin, roleId.operationDirector, roleId.regionalDirector].includes(user.role.id) && 
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <button onClick={() => onChangeEdit('plan')} className={`btn ${changed === 'plan' ? 'btn-primary' : 'btn-secondary'}`}>
                                Редактирование плана
                            </button>
                            <button onClick={() => onChangeEdit('result')} className={`btn ${changed === 'result' ? 'btn-primary' : 'btn-secondary'}`}>
                                Редактирование факта
                            </button>
                        </div>
                    }
                </div>
            </div>
        )
    }

    const onChangeStaffData = (value, field, index) => {
        if (!field || isNotNumber(index)) return;
        const updated = {...data};
        if (field === 'firstRate') updated.revenuesStaff[index].secondRate = value;
        if (field === 'pendingFirstRate') updated.revenuesStaff[index].pendingSecondRate = value;
        if (field === 'firstPrizeRevenue') updated.revenuesStaff[index].secondPrizeRevenue = value;
        if (field === 'firstSumRevenuePrize') updated.revenuesStaff[index].secondSumRevenuePrize = value;
        updated.revenuesStaff[index][field] = value;
        updated.revenuesStaff[index].isChangeData = true;
        setData(updated);
    };

    const onChangeRevenue = (value, mainIndex, index) => {
        if (isNotNumber(mainIndex) || isNotNumber(index)) return;
        const updated = {...data};
        const field = changed;

        if (mainIndex === 'revenue') {
            updated.revenue.revenues[index].sum[field] = value;
            updated.revenue.isChange = true;
        } else {
            updated.revenuesStaff[mainIndex].revenues[index].sum[field] = value;
            updated.revenuesStaff[mainIndex].isChange = true;
        }

        setData(updated);
    }

    const getRenderTotal = (data) => {
        if (!data) return 0;
        if (!isNotNumber(data.result) && changed === 'result') return data.result;
        if (user.role.id === roleId.cashier) return data.result || 0;
        return data.plan || 0;
    }

    const getStaffName = (item) => {
        if (!item) return;
        if (item.actualName) return item.actualName;
        if (item.staffId) {
            const entity = staff.find((el) => el.id === item.staffId);
            if (entity) return entity.name;
        }
        return item.name;
    }

    const onSave = async () => {
        const result = await dispatch(saveWageFundData(data.revenue.id, data, data.revenue.startOfMonthDate));
        if (result && !result.error) return swal({
            title: `Данные успешно сохранены`,
            icon: "success",
            button: "Ок",
            timer: 2000,
        }).then(() => onRefresh(true));

        return swal({
            title: `Произошла ошибка при сохранении данных`,
            icon: "warning",
            dangerMode: true,
            button: "Ок",
        });
    }

    const handleDeleteRow = (index, name) => {
        if (isNotNumber(index)) return;

        return swal({
            title: `Вы удаляете запись о сотруднике ${name} за месяц`,
            text: 'Данные будут удалены без возможности восстановления. Вы удалите только запись о сотруднике за выбранный месяц, для полного удаления - перейдите в раздел "Сотрудники (табель)" и удалите данные о сотруднике там.',
            icon: "warning",
            dangerMode: true,
            buttons: ["Отмена", "Удалить"],
        }).then((accept) => {
            if (accept) {
                const updated = {...data};

                updated.revenuesStaff[index].isChange = true;
                updated.revenuesStaff[index].isDelete = true;
                setData(updated);
            }
        });
    }

    const onDeletePrize = (id, index) => {
        const updated = {
            ...data,
            revenuesStaff: data.revenuesStaff.map((r) => {
                if (r.id !== id) return r;
                return { 
                    ...r,
                    prize: r.prize.map((prize, prizeIndex) => {
                        if (prizeIndex !== index) return prize;
                        return { ...prize, isDeleted: true }
                    }),
                    isChange: true,
                }
            })
        };
        setData(updated);
    }

    const onAddPrize = (prize) => {
        const { date, sum, type, comment, staffId } = prize;
        const updated = {
            ...data,
            revenuesStaff: data.revenuesStaff.map((r) => {
                if (r.staffId !== staffId) return r;
                return { 
                    ...r,
                    prize: [ ...(r.prize || []), { date, sum, type, comment, isNew: true }],
                    isChange: true,
                }
            })
        };
        setData(updated);
    }

    const onSavePrize = (prizes) => {
        const updated = { ...data }
        let revenuesStaffUpdated = [...updated.revenuesStaff];
        prizes.forEach((prize) => {
            if (prize.isChangeStaff) {
                revenuesStaffUpdated = revenuesStaffUpdated.map((item) => {
                    if (item.id === prize.id) return { 
                        ...item,
                        prize: item.prize.map((p, prizeIndex) => {
                            if (prizeIndex !== prize.index) return p;
                            return { ...p, isSend: true, sendTo: prize.staffId }
                        }),
                        isChange: true,
                    }

                    if (item.staffId === prize.staffId) return {
                        ...item,
                        prize: [ ...(item.prize || []), { date: prize.date, sum: prize.sum, type: prize.type, comment: prize.comment, isTake: true }],
                        isChange: true,
                    }

                    return item;
                    
                });
            } else {
                revenuesStaffUpdated = revenuesStaffUpdated.map((item) => {
                    if (item.id !== prize.id) return item;
                    return {
                        ...item,
                        prize: (item.prize || []).map((p, index) => {
                            if (index !== prize.index) return p;
                            return { date: prize.date, sum: prize.sum, type: prize.type, comment: prize.comment, isTake: true }
                        }),
                        isChange: true,
                    }
                });
            }
        });
        updated.revenuesStaff = revenuesStaffUpdated;
        setData(updated);
    }

    const getPercentStaff = (staff, index, staffs) => {
        if (!staff || isEmpty(staff.revenues)) return 0;
        const percentsPosts = (!isEmpty(data.revenue) && !isEmpty(data.revenue.percentsPosts)) ? data.revenue.percentsPosts || {} : {}
        const percent = !isEmpty(percentsPosts) ? percentsPosts[String(staff.postId)] || 0 : 0;
        if (percent === 0) return 0;

        if (isEmpty(staff.revenues[index]) || isEmpty(staff.revenues[index].sum)) return 0;
        if (isNotNumber(staff.revenues[index].sum.result) && isNotNumber(staff.revenues[index].sum.plan)) return 0;

        const hours = !isNotNumber(staff.revenues[index].sum.result) ? staff.revenues[index].sum.result : staff.revenues[index].sum.plan;
        if (!hours) return 0;

        const postStaffsWork = (staffs || []).filter((entityStaff) => {
            if (entityStaff.id === staff.id) return false;
            if (isEmpty(entityStaff.revenues[index])) return false;
            if (!isNotNumber(entityStaff.revenues[index].sum.result) || !isNotNumber(entityStaff.revenues[index].sum.plan)) return true;
            return false;
        });

        const postStaffsHours = (postStaffsWork || []).reduce((acc, entityStaff) => {
            if (!isNotNumber(entityStaff.revenues[index].sum.result)) return acc += +entityStaff.revenues[index].sum.result;
            if (!isNotNumber(entityStaff.revenues[index].sum.plan)) return acc += +entityStaff.revenues[index].sum.plan;
            return acc;
        }, 0);
        
        const dataDate = data.revenue.revenues[index];
        if (isEmpty(dataDate)) return 0;

        const revenueDate = !isNotNumber(dataDate.sum.result) ? dataDate.sum.result : dataDate.sum.plan || 0;
        if (!revenueDate) return 0;
        const allHours = +postStaffsHours + +hours;
    
        const allPercent = roundToFixed(revenueDate * (percent / 100));
        const hourPercent = roundToFixed(allPercent / allHours);
        
        if (hours > 0 && revenueDate > 0 && hourPercent > 0) return roundToFixed(hourPercent * hours) || 0;
    }
    
    const getPrizeRevenueStaff = (staff, index) => {
        if (!staff || isEmpty(staff.revenues)) return 0;
        if (isEmpty(staff.revenues[index]) || isEmpty(staff.revenues[index].sum)) return 0;
        if (isNotNumber(staff.revenues[index].sum.result) && isNotNumber(staff.revenues[index].sum.plan)) return 0;

        const fieldPrize = index > 14 ? 'secondPrizeRevenue' : 'firstPrizeRevenue';
        const valuePrize = staff[fieldPrize] || staff.firstPrizeRevenue || 0;
        if (!valuePrize) return 0;

        const fieldSum = index > 14 ? 'secondSumRevenuePrize' : 'firstSumRevenuePrize';
        const minSum = staff[fieldSum] || staff.firstSumRevenuePrize || 0;

        const hours = !isNotNumber(staff.revenues[index].sum.result) ? staff.revenues[index].sum.result : staff.revenues[index].sum.plan;
        if (!hours) return 0;
        
        const dataDate = data.revenue.revenues[index];
        if (isEmpty(dataDate)) return 0;
        const normalShift = !isEmpty(data.revenue) ? data.revenue.normalShift || 13 : 13

        const revenueDate = !isNotNumber(dataDate.sum.result) ? dataDate.sum.result : dataDate.sum.plan || 0;
        if (!revenueDate || revenueDate < minSum) return 0;
        if (hours >= normalShift) return valuePrize || 0;
        return roundToFixed((valuePrize / normalShift) * hours) || 0;
    }

    const getPrizeStaff = (staff, index) => {
        if (!staff || isEmpty(staff.prize)) return 0;
        const currentDate = moment(data.revenue.startOfMonthDate).add(index, 'days').format('YYYY-MM-DD');
        const filteredPrizes = staff.prize.filter((prize) => !prize.isDeleted && prize.date === currentDate);
        if (isEmpty(filteredPrizes)) return 0;
        return filteredPrizes.reduce((acc, prize) => {
            if (!prize || !prize.sum) return 0;
            if (prize.type === 'depremation') {
                acc -= +prize.sum
            } else {
                acc += +prize.sum
            }
            return acc;
        }, 0);
    }

    const renderStaffData = (item, postStaff) => {
        const totalHours = calculateTotal(item.revenues);

        const getPrize = (type) => {
            if (!item || isEmpty(item.prize)) return 0;
            const start = moment(data.revenue.startOfMonthDate);
            let minDate, maxDate;

            if (type === 'first') {
                minDate = start.clone().startOf('day');
                maxDate = start.clone().add(14, 'days').endOf('day');
            } else {
                minDate = start.clone().add(15, 'days').startOf('day');
                maxDate = start.clone().endOf('month');
            }

            return item.prize.reduce((acc, prize) => {
                if (prize.isDeleted) return acc;
                const prizeDate = moment(prize.date, 'YYYY-MM-DD');
                if (prizeDate.isBetween(minDate, maxDate, 'day', '[]')) {
                    if (prize.type === 'prize') return acc + (prize.sum || 0);
                    return acc - (prize.sum || 0);
                }
                return acc;
            }, 0);
        };

        const getPercent = (type) => {
            if (!item || isEmpty(item.revenues)) return 0;

            const percent = (!isEmpty(data.revenue) && !isEmpty(data.revenue.percentsPosts)) ? data.revenue.percentsPosts[String(item.postId)] || 0 : 0;
            if (percent === 0) return 0;

            const start = moment(data.revenue.startOfMonthDate);
            let minDate, maxDate;

            if (type === 'first') {
                minDate = start.clone().startOf('day');
                maxDate = start.clone().add(14, 'days').endOf('day');
            } else {
                minDate = start.clone().add(15, 'days').startOf('day');
                maxDate = start.clone().endOf('month');
            }

            return item.revenues.reduce((acc, revenue, index) => {
                const currentDate = moment(start).add(index, 'days');
                if (currentDate.isBetween(minDate, maxDate, 'day', '[]')) {
                    const postStaffsWork = (postStaff || []).filter((entityStaff) => {
                        if (entityStaff.id === item.id) return false;
                        if (isEmpty(entityStaff.revenues[index])) return false;
                        if (!isNotNumber(entityStaff.revenues[index].sum.result) || !isNotNumber(entityStaff.revenues[index].sum.plan)) return true;
                        return false;
                    });

                    const postStaffsHours = (postStaffsWork || []).reduce((acc, entityStaff) => {
                        if (!isNotNumber(entityStaff.revenues[index].sum.result)) return acc += +entityStaff.revenues[index].sum.result;
                        if (!isNotNumber(entityStaff.revenues[index].sum.plan)) return acc += +entityStaff.revenues[index].sum.plan;
                        return acc;
                    }, 0);

                    const hours = !isNotNumber(revenue.sum.result) ? revenue.sum.result : revenue.sum.plan || 0;

                    const allHours = +postStaffsHours + +hours;

                    const dataDate = data.revenue.revenues[index] || 0;
                    const revenueDate = !isNotNumber(dataDate.sum.result) ? dataDate.sum.result : dataDate.sum.plan || 0;

                    const allPercent = roundToFixed(revenueDate * (percent / 100));
                    const hourPercent = roundToFixed(allPercent / allHours);

                    if (hours > 0 && revenueDate > 0 && hourPercent > 0) return acc += roundToFixed(hourPercent * hours) || 0;
                }
                return acc;
            }, 0);
        }

        const getRevenuePrize = (type) => {
            if (!item || isEmpty(item.revenues)) return 0;

            const start = moment(data.revenue.startOfMonthDate);
            let minDate, maxDate;

            if (type === 'first') {
                minDate = start.clone().startOf('day');
                maxDate = start.clone().add(14, 'days').endOf('day');
            } else {
                minDate = start.clone().add(15, 'days').startOf('day');
                maxDate = start.clone().endOf('month');
            }

            return item.revenues.reduce((acc, revenue, index) => {
                const currentDate = moment(start).add(index, 'days');
                if (currentDate.isBetween(minDate, maxDate, 'day', '[]')) {
                    const normalShift = !isEmpty(data.revenue) ? data.revenue.normalShift || 13 : 13;
                    const hours = !isNotNumber(revenue.sum.result) ? revenue.sum.result : revenue.sum.plan || 0;
                    const dataDate = data.revenue.revenues[index] || 0;
                    const revenueDate = !isNotNumber(dataDate.sum.result) ? dataDate.sum.result : dataDate.sum.plan || 0;
                    const minSum = type === 'first' ? item.firstSumRevenuePrize || 0 : item.secondSumRevenuePrize || item.firstSumRevenuePrize || 0;
                    const prize = type === 'first' ? item.firstPrizeRevenue || 0 : item.secondPrizeRevenue || item.firstPrizeRevenue || 0;
                    let sum = 0;
                    if (hours > 0 && revenueDate > minSum && prize > 0) {
                        if (hours >= normalShift) {
                            sum = prize;
                        } else {
                            sum = roundToFixed((prize / normalShift) * hours);
                        }
                        return acc += +sum;
                    }
                }
                return acc;
            }, 0);
        }

        const totalRevenues = {
            first: 0,
            second: 0,
        };

        if (renderRevenueStaff === 'hours' || renderRevenueStaff === 'fullSum' || renderRevenueStaff === 'prizeSum') {
            totalRevenues.first = parseNumToFixed(totalRevenues.first + (getPrize('first') + (getPercent('first') || 0) + (getRevenuePrize('first') || 0))) || 0;
            totalRevenues.second = parseNumToFixed(totalRevenues.second + (getPrize('second')) + (getPercent('second') || 0) + (getRevenuePrize('second') || 0)) || 0;
        }

        if (renderRevenueStaff === 'hours' || renderRevenueStaff === 'fullSum' || renderRevenueStaff === 'sum') {
            totalRevenues.first = parseNumToFixed(totalRevenues.first + getRenderTotal(totalHours.first) * (item.firstRate || 0));
            totalRevenues.second = parseNumToFixed(totalRevenues.second + getRenderTotal(totalHours.second) * (item.secondRate || item.firstRate || 0));
        }

        const disabledChangesCashier = (index) => {
            if (user.role.id !== roleId.cashier) return false;
            if (moment().format('DD.MM.YYYY') === moment(data.revenue.startOfMonthDate).add(index, 'days').format('DD.MM.YYYY')) return false;
            return true;
        }

        const isPendingFirstRate = item.pendingFirstRate ? true : false;
        const isPendingSecondRate = isPendingFirstRate ? isPendingFirstRate : item.pendingSecondRate ? true : false;

        const handleMouseDown = (e) => {
            if (e.button === 2) e.preventDefault();
        };

        const aprovePending = (field, itemIndex) => {
            const updated = { ...data };
            const currentStaff = updated.revenuesStaff[itemIndex];
            if (field === 'firstRate') {
                currentStaff.firstRate = currentStaff.pendingFirstRate;
                currentStaff.secondRate = currentStaff.pendingFirstRate;
                currentStaff.pendingFirstRate = null;
                currentStaff.pendingSecondRate = null;
            } else {
                currentStaff.secondRate = currentStaff.pendingSecondRate;
                currentStaff.pendingSecondRate = null;
            }
            currentStaff.isChangeData = true;
            setData(updated);
        }

        const cancelPending = (field, itemIndex) => {
            const updated = { ...data };
            const currentStaff = updated.revenuesStaff[itemIndex];
            if (field === 'firstRate') {
                currentStaff.pendingFirstRate = null;
                currentStaff.pendingSecondRate = null;
            } else {
                currentStaff.pendingSecondRate = null;
            }
            currentStaff.isChangeData = true;
            setData(updated);
        }

        const actualizeRate = async (field, itemIndex) => {
            const updated = { ...data };
            const currentStaff = updated.revenuesStaff[itemIndex];
            let isUpdate = false;

            if (field === 'firstRate') {
                const params = {
                    staffId: currentStaff.staffId,
                    startOfMonthDate: currentStaff.startOfMonthDate,
                }

                const prevStaffData = await request({ method: 'post', url: `${urls.revenuesstaffs}/getLastRate`, data: params });
                if (!isEmpty(prevStaffData)) {
                    if (!!prevStaffData.lastRate && prevStaffData.lastRate !== currentStaff.firstRate) {
                        currentStaff.firstRate = prevStaffData.lastRate;
                        currentStaff.secondRate = prevStaffData.lastRate;
                        currentStaff.isChangeData = true;
                        isUpdate = true;
                    }

                    if (!!prevStaffData.lastPrizeRevenue && prevStaffData.lastPrizeRevenue !== currentStaff.firstPrizeRevenue) {
                        currentStaff.firstPrizeRevenue = prevStaffData.lastPrizeRevenue;
                        currentStaff.secondPrizeRevenue = prevStaffData.lastPrizeRevenue;
                        currentStaff.isChangeData = true;
                        isUpdate = true;
                    }

                    if (!!prevStaffData.lastSumRevenuePrize && prevStaffData.lastSumRevenuePrize !== currentStaff.firstSumRevenuePrize) {
                        currentStaff.firstSumRevenuePrize = prevStaffData.lastSumRevenuePrize;
                        currentStaff.secondSumRevenuePrize = prevStaffData.lastSumRevenuePrize;
                        currentStaff.isChangeData = true;
                        isUpdate = true;
                    }
                } else {
                    return swal({
                        title: 'Актуализация данных недоступна',
                        text: 'Не удалось найти более ранние сведения о сотруднике',
                        icon: "error",
                        button: "Ок",
                        timer: 2000,
                    });
                }
            } else {
                if (!currentStaff.secondRate || currentStaff.secondRate !== currentStaff.firstRate) {
                    currentStaff.secondRate = currentStaff.firstRate;
                    currentStaff.isChangeData = true;
                    isUpdate = true;
                }

                if (!currentStaff.secondPrizeRevenue || currentStaff.secondPrizeRevenue !== currentStaff.firstPrizeRevenue) {
                    currentStaff.secondPrizeRevenue = currentStaff.firstPrizeRevenue;
                    currentStaff.isChangeData = true;
                    isUpdate = true;
                }

                if (!currentStaff.secondSumRevenuePrize || currentStaff.secondSumRevenuePrize !== currentStaff.firstSumRevenuePrize) {
                    currentStaff.secondSumRevenuePrize = currentStaff.firstSumRevenuePrize;
                    currentStaff.isChangeData = true;
                    isUpdate = true;
                }
            }

            if (isUpdate) setData(updated);
        }
        
        const handleRightClick = (field, itemIndex) => (e) => {
            e.preventDefault();
            if (![roleId.admin, roleId.operationDirector, roleId.regionalDirector].includes(user.role.id)) return;
            const staffItem = (data && data.revenuesStaff && data.revenuesStaff[itemIndex]) ? data.revenuesStaff[itemIndex] : null;
            if (!staffItem) return;

            let isPending;
            if (field === 'secondRate' && (isPendingSecondRate || isPendingFirstRate)) isPending = true;
            if (field === 'firstRate' && isPendingFirstRate) isPending = true;
            
            const actions = [
                ...(isPending ? [
                    { name: 'Принять', icon: 'flaticon2-check-mark', style: { color: '#0abb87' }, action: () => aprovePending(field, itemIndex) },
                    { name: 'Отклонить', icon: 'flaticon2-delete', style: { color: '#fd397a' }, action: () => cancelPending(field, itemIndex) },
                ] : []),
                { name: 'Актуализировать ставку и премию', icon: 'la la-refresh', style: { color: '#595d6e' }, action: () => actualizeRate(field, itemIndex) },
            ];

            if (!actions || actions.length === 0) return;

            contextMenuRef.current.open(e, actions, containerRef.current);
        };

        const handleTouchStart = (field, itemIndex) => (e) => {
            if (!e.touches || e.touches.length === 0) return;
            
        const touch = e.touches[0];
        const timer = setTimeout(() => {
            const fakeEvent = {
            preventDefault: () => {},
            clientX: touch.clientX,
            clientY: touch.clientY,
            button: 2,
            };
            handleRightClick(field, itemIndex)(fakeEvent);
        }, 600);
        setPressTimer(timer);
        };
        
        const handleTouchEnd = () => {
        if (pressTimer) {
            clearTimeout(pressTimer);
            setPressTimer(null);
        }
        };

        totalRevenues.total = parseNumToFixed((totalRevenues.first || 0) + (totalRevenues.second || 0)) || 0;
        const renderCells = () => { return item.revenues.map((revenue, index) => {
                if (period.start.index && index < period.start.index) return null;
                if (period.end.index && index > period.end.index) return null;

                const renderHours = renderItemSum(revenue);
                const disabled = disabledChangesCashier(index);
                const styles = weekendsDaysIndexes.includes(index) ? { ...stylesTable.sm, backgroundColor: '#ffefd8' } : stylesTable.sm;

                const currentDate = moment(data.revenue.startOfMonthDate).add(index, 'days').startOf('day');
                const textColor = currentDate.isAfter(moment().startOf('day')) ? 'gray' : renderHours.color;

                const calculateCellSum = () => {
                    let total = 0;
                    if (renderRevenueStaff === 'fullSum' || renderRevenueStaff === 'prizeSum') {
                        if (!isEmpty(item.prize)) {
                            const prizes = item.prize.filter((prize) => !prize.isDeleted && prize.date === date);
                            if (!isEmpty(prizes)) prizes.forEach((prize) => {
                                if (prize.type === 'prize') {
                                    total += (+prize.sum || 0);
                                } else {
                                    total -= (+prize.sum || 0);
                                }
                            });
                        }

                        const percentSum = getPercentStaff(item, index, postStaff);
                        if (percentSum) total += +percentSum || 0;

                        const handlePrizeSum = getPrizeStaff(item, index);
                        if (handlePrizeSum) total += +handlePrizeSum || 0;

                        const prizeRevenueSum = getPrizeRevenueStaff(item, index);
                        if (prizeRevenueSum) total += +prizeRevenueSum || 0;
                    }

                    if (renderRevenueStaff === 'fullSum' || renderRevenueStaff === 'sum') {
                        if (index > 14) {
                            total += +roundToFixed((renderHours.sum || 0) * (item.secondRate || item.firstRate || 0)) || 0;
                        } else {
                            total += +roundToFixed((renderHours.sum || 0) * (item.firstRate || 0)) || 0;
                        }
                    }

                    return formatNumberWithSpaces(roundToFixed(total, 0));
                }

                if (index !== 14 || (index === 14 && period.end.index === 14)) {
                    return (
                        <td key={`staff-${index}`} style={{ ...styles, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                            {renderRevenueStaff === 'hours' ?
                                <input
                                disabled={disabled ? disabled : index > 14 ? isBlockSecond : isBlockFirst}
                                onFocus={(e) => e.target.select()}
                                className="no-number-spinner"
                                style={{ ...stylesTable.input, color: textColor, fontWeight: 600 }} 
                                value={(renderHours.sum || renderHours.sum === 0) ? renderHours.sum : ''}
                                type="number"
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (value > 0) return onChangeRevenue(parseNumToFixed(value), item.index, index);
                                    return onChangeRevenue(0, item.index, index);
                                }}
                                />
                            :
                                <span style={{ color: textColor }}>{calculateCellSum()} руб.</span>
                            }
                        </td>
                    );
                }
                return (
                    <React.Fragment key={`staff-group-${index}`}>
                        <td style={{ ...styles, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                            {renderRevenueStaff === 'hours' ?
                                <input
                                disabled={disabled ? disabled : isBlockFirst}
                                onFocus={(e) => e.target.select()}
                                className="no-number-spinner"
                                style={{ ...stylesTable.input, color: renderHours.color, fontWeight: 600 }} 
                                value={(renderHours.sum || renderHours.sum === 0) ? renderHours.sum : ''}
                                type="number"
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (value > 0) return onChangeRevenue(parseNumToFixed(value, 0), item.index, index);
                                    return onChangeRevenue(0, item.index, index);
                                }}
                                />
                            :
                                <span style={{ color: textColor }}>{calculateCellSum()} руб.</span>
                            }
                        </td>
                        <td style={user.role.id !== roleId.cashier ? { ...stylesTable.sm, ...stylesTable.borderLeft, backgroundColor: changed === 'result' ? totalHours.first.color : null } : { ...stylesTable.sm, ...stylesTable.borderLeft, ...stylesTable.borderRight, backgroundColor: changed === 'result' ? totalHours.first.color : null }} className="kt-datatable__cell">
                            {roundToFixed(+getRenderTotal(totalHours.first), 2)}
                        </td>
                        {user.role.id !== roleId.cashier && <td style={{ ...stylesTable.md, ...stylesTable.borderLeft, ...stylesTable.borderRight }} className="kt-datatable__cell">
                            {formatNumberWithSpaces(roundToFixed(totalRevenues.first, 0))}
                        </td>}
                        <StaffNameCell
                        value={getStaffName(item)}
                        index={item.index}
                        disabled={(isBlockFirst && isBlockSecond) || ![roleId.admin, roleId.operationDirector, roleId.regionalDirector, roleId.manager].includes(user.role.id)}
                        onNameChange={onChangeStaffData}
                        onDelete={handleDeleteRow}
                        showDelete={[roleId.admin, roleId.manager, roleId.operationDirector, roleId.regionalDirector].includes(user.role.id)}
                        stylesTable={stylesTable}
                        userRoleId={user.role.id}
                        />
                        {user.role.id !== roleId.cashier && 
                        <>
                        <td onTouchStart={handleTouchStart('secondRate', item.index)} onTouchEnd={handleTouchEnd} onTouchCancel={handleTouchEnd} onContextMenu={handleRightClick('secondRate', item.index)} style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                            {([roleId.admin, roleId.operationDirector, roleId.regionalDirector].includes(user.role.id) && (item.pendingSecondRate || item.pendingFirstRate)) ?
                            <button className="blink-text" onClick={handleRightClick('secondRate', item.index)} style={{ ...stylesTable.input, color: '#e89700' }}>
                                {item.pendingSecondRate || item.pendingFirstRate}
                            </button>
                            :
                            <input
                            disabled={isBlockSecond || ![roleId.admin, roleId.manager, roleId.operationDirector, roleId.regionalDirector].includes(user.role.id)}
                            onFocus={(e) => e.target.select()}
                            onMouseDown={handleMouseDown}
                            className="no-number-spinner"
                            style={(isPendingFirstRate || isPendingSecondRate) ? { ...stylesTable.input, color: 'orange' } : { ...stylesTable.input }} 
                            value={item.pendingSecondRate || item.pendingFirstRate || item.secondRate || item.firstRate || 0}
                            type="number"
                            onChange={(e) => {
                                const value = e.target.value;
                                const field = user.role.id !== roleId.manager ? 'secondRate' : 'pendingSecondRate';
                                if (value > 0) return onChangeStaffData(parseNumToFixed(value), field, item.index);
                                return onChangeStaffData(0, field, item.index);
                            }}
                            />
                            }
                            
                        </td>
                        {openPrizesColumns &&
                            <>
                            <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                                <input
                                disabled={isBlockSecond || ![roleId.admin, roleId.operationDirector, roleId.regionalDirector].includes(user.role.id)}
                                onFocus={(e) => e.target.select()}
                                className="no-number-spinner"
                                style={stylesTable.input} 
                                value={item.secondPrizeRevenue || item.firstPrizeRevenue || 0}
                                type="number"
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (value > 0) return onChangeStaffData(parseNumToFixed(value), 'secondPrizeRevenue', item.index);
                                    return onChangeStaffData(0, 'secondPrizeRevenue', item.index);
                                }}
                                />
                            </td>
                            <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                                <input
                                disabled={isBlockSecond || ![roleId.admin, roleId.operationDirector, roleId.regionalDirector].includes(user.role.id)}
                                onFocus={(e) => e.target.select()}
                                className="no-number-spinner"
                                style={stylesTable.input} 
                                value={item.secondSumRevenuePrize || item.firstSumRevenuePrize || 0}
                                type="number"
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (value > 0) return onChangeStaffData(parseNumToFixed(value), 'secondSumRevenuePrize', item.index);
                                    return onChangeStaffData(0, 'secondSumRevenuePrize', item.index);
                                }}
                                />
                            </td>
                            </>
                        }
                        </>
                        }
                    </React.Fragment>
                );
            });
        }

        return (
        <tr style={stylesTable.outline} className="kt-datatable__row">
            <StaffNameCell
            value={getStaffName(item)}
            index={item.index}
            disabled={(isBlockFirst && isBlockSecond) || ![roleId.admin, roleId.operationDirector, roleId.regionalDirector, roleId.manager].includes(user.role.id)}
            disabledDelete = {isBlockFirst || isBlockSecond}
            onNameChange={onChangeStaffData}
            onDelete={handleDeleteRow}
            showDelete={[roleId.admin, roleId.manager, roleId.operationDirector, roleId.regionalDirector].includes(user.role.id)}
            stylesTable={stylesTable}
            userRoleId={user.role.id}
            />
            {user.role.id !== roleId.cashier && 
            <>
            <td onTouchStart={handleTouchStart('firstRate', item.index)} onTouchEnd={handleTouchEnd} onTouchCancel={handleTouchEnd} onContextMenu={handleRightClick('firstRate', item.index)} style={{ ...stylesTable.sm, ...stylesTable.borderLeft, ...stylesTable.borderRight }} className="kt-datatable__cell">
            {([roleId.admin, roleId.operationDirector, roleId.regionalDirector].includes(user.role.id) && item.pendingFirstRate) ?
                <button className="blink-text" onClick={handleRightClick('firstRate', item.index)} style={{ ...stylesTable.input, color: '#e89700' }}>
                    {item.pendingFirstRate}
                </button>
                :
                <input
                disabled={isBlockFirst || ![roleId.admin, roleId.manager, roleId.operationDirector, roleId.regionalDirector].includes(user.role.id)}
                onFocus={(e) => e.target.select()}
                onMouseDown={handleMouseDown}
                className="no-number-spinner"
                style={isPendingFirstRate ? { ...stylesTable.input, color: 'orange' } : { ...stylesTable.input }} 
                value={item.pendingFirstRate || item.firstRate || 0}
                type="number"
                onChange={(e) => {
                    const value = e.target.value;
                    const field = user.role.id !== roleId.manager ? 'firstRate' : 'pendingFirstRate';
                    if (value > 0) return onChangeStaffData(parseNumToFixed(value), field, item.index);
                    return onChangeStaffData(0, field, item.index);
                }}
                />
            }
            </td>
            {openPrizesColumns &&
            <>
                <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                    <input
                    disabled={isBlockSecond || ![roleId.admin, roleId.operationDirector, roleId.regionalDirector].includes(user.role.id)}
                    onFocus={(e) => e.target.select()}
                    className="no-number-spinner"
                    style={stylesTable.input} 
                    value={item.firstPrizeRevenue || 0}
                    type="number"
                    onChange={(e) => {
                        const value = e.target.value;
                        if (value > 0) return onChangeStaffData(parseNumToFixed(value), 'firstPrizeRevenue', item.index);
                        return onChangeStaffData(0, 'firstPrizeRevenue', item.index);
                    }}
                    />
                </td>
                <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                    <input
                    disabled={isBlockSecond || ![roleId.admin, roleId.operationDirector, roleId.regionalDirector].includes(user.role.id)}
                    onFocus={(e) => e.target.select()}
                    className="no-number-spinner"
                    style={stylesTable.input} 
                    value={item.firstSumRevenuePrize || 0}
                    type="number"
                    onChange={(e) => {
                        const value = e.target.value;
                        if (value > 0) return onChangeStaffData(parseNumToFixed(value), 'firstSumRevenuePrize', item.index);
                        return onChangeStaffData(0, 'firstSumRevenuePrize', item.index);
                    }}
                    />
                </td>
            </>
            }
            </>
            }
            {renderCells()}
            <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft, backgroundColor: changed === 'result' ? (!period.end.index || period.end.index > 14) ? totalHours.second.color : totalHours.first.color : null }} className="kt-datatable__cell">
                {(!period.end.index || period.end.index > 14) ? roundToFixed(+getRenderTotal(totalHours.second), 2) : roundToFixed(getRenderTotal(totalHours.first), 2)}
            </td>
            {user.role.id !== roleId.cashier && <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                {(!period.end.index || period.end.index > 14) ? formatNumberWithSpaces(roundToFixed(totalRevenues.second, 0)) : formatNumberWithSpaces(roundToFixed(totalRevenues.first, 0))}
            </td>}
            <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft, backgroundColor: changed === 'result' ? totalHours.total.color : null }} className="kt-datatable__cell">
                {roundToFixed(getRenderTotal(totalHours.total), 2)}
            </td>
            {user.role.id !== roleId.cashier && <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                {formatNumberWithSpaces(roundToFixed(totalRevenues.total, 0))}
            </td>}
        </tr>
        )
    }

    const onCloseModal = () => setModal(null);

    const renderNewStaffModal = () => {
        if (!modal || modal.type !== 'new') return null;

        const onSubmit = () => {
            const daysCount = moment(data.revenue.startOfMonthDate).daysInMonth();
            const dataMonth = Array.from({ length: daysCount }, () => ({ sum: { plan: null } }));
            const newStaffData = { ...newStaff, revenueId: data.revenue.id, firstRate: (newStaff.lastRate || 0), secondRate: (newStaff.lastRate || 0), isChange: true, isNew: true, revenues: dataMonth, startOfMonthDate: data.revenue.startOfMonthDate };
            const updated = {...data};
            if (!isEmpty(updated.revenuesStaff)) {
                updated.revenuesStaff.push(newStaffData);
            } else {
                updated.revenuesStaff = [newStaffData];
            }
            setData(updated);
            onCloseModal();
        }

        return (
            <form>
                <div className="modal fade show" style={{ display: 'block' }}>
                    <div className="modal-dialog modal-lg modal-dialog-scrollable" style={{ height: '90%', alignItems: 'center', justifyContent: 'center' }}>
                    <div ref={modalRef} className="modal-content">
                        <div className="modal-header">
                        <h5 className="modal-title"> Добавление нового сотрудника </h5>
                        <button onClick={onCloseModal} type="button" className="close">
                        </button>
                        </div>
                        <div ref={modalRef} className="modal-body">
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                <Input
                                    label="ФИО"
                                    required={true}
                                    value={newStaff.name}
                                    placeholder="ФИО..."
                                    onChange = {(e) => setNewStaff({ ...newStaff, name: e.target.value})}
                                />
                                {[roleId.admin, roleId.operationDirector, roleId.regionalDirector].includes(user.role.id) &&
                                    <Input
                                        label="Ставка"
                                        type="number"
                                        required={true}
                                        value={newStaff.lastRate || 0}
                                        placeholder="Ставка..."
                                        onChange = {(e) => setNewStaff({ ...newStaff, lastRate: parseNumToFixed(e.target.value)})}
                                    />
                                }
                            </div>
                        </div>
            
                        <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onCloseModal}>Отмена</button>
                        <button type="button" onClick={onSubmit} disabled={!newStaff || !newStaff.name} className="btn btn-primary"> Сохранить </button>
                        </div>
                    </div>
                    </div>
                </div>
            </form>
        );
    }

    const renderPrizesModal = () => {
        if (!modal || modal.type !== 'prizes') return null;
        const { post, period } = modal;

        const onClose = () => {
            setPrizes({ percent: null, prizeRevenue: null, sumRevenuePrize: null });
            onCloseModal();
        }

        const onSubmit = () => {
            return swal({
                title: "Обновление данных премирования",
                text: `Внесенные данные будут применены ко всем сотрудникам должности "${post.label}"`,
                icon: "warning",
                dangerMode: true,
                buttons: ["Отмена", "Ок"],
            }).then((accept) => {
                if (!accept) return;
            
                const staff = (data.revenuesStaff && data.revenuesStaff.length > 0) ? [...data.revenuesStaff] : null;
                const indexesStaff = (staff || []).map((item, index) => ({ ...item, index })).filter(item => item.postId === post.id && !item.isDelete && !item.isDeleted).map((item) => item.index);

                if (indexesStaff.length === 0) return;
          
                setData((prev) => {
                    const newRevenuesStaff = [...prev.revenuesStaff];

                    for (const index of indexesStaff) {
                        if (!isNotNumber(prizes.prizeRevenue)) {
                            const field = period === 'first' ? 'firstPrizeRevenue' : 'secondPrizeRevenue'
                            newRevenuesStaff[index][field] = prizes.prizeRevenue;
                        }

                        if (!isNotNumber(prizes.sumRevenuePrize)) {
                            const field = period === 'first' ? 'firstSumRevenuePrize' : 'secondSumRevenuePrize'
                            newRevenuesStaff[index][field] = prizes.sumRevenuePrize;
                        }
                        
                        newRevenuesStaff[index].isChangeData = true;
                    }

                    return { ...prev, revenuesStaff: newRevenuesStaff };
                });

                setPrizes({ percent: null, prizeRevenue: null, sumRevenuePrize: null });
            });
        };

        const onChangePrizes = (value, field) => {
            if (!value || !field) return;
            const updated = { ...prizes };
            updated[field] = parseFloat(value);
            setPrizes(updated);
        }

        return (
            <form>
                <div  className="modal fade show" style={{ display: 'block' }}>
                    <div className="modal-dialog modal-lg modal-dialog-scrollable" style={{ height: '90%', alignItems: 'center', justifyContent: 'center' }}>
                    <div ref={modalRef} className="modal-content" style={{ height: '80%' }}>
                        <div className="modal-header">
                        <h5 className="modal-title"> {`Изменение премирования должности "${post.label}"`} </h5>
                        <button onClick={onClose} type="button" className="close">
                        </button>
                        </div>
                        <div ref={modalRef} className="modal-body">
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <label style={{ color: '#000' }}>
                                        Премия от выручки
                                    </label>
                                    <input
                                        disabled={isBlockSecond || isBlockFirst}
                                        onFocus={(e) => e.target.select()}
                                        className="form-control neworder"
                                        style={{ width: '50%' }}
                                        value={prizes.prizeRevenue}
                                        type="number"
                                        onChange={(e) => onChangePrizes(e.target.value, 'prizeRevenue')}
                                    />
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <label style={{ color: '#000' }}>
                                        Сумма выручки для премии
                                    </label>
                                    <input
                                        disabled={isBlockSecond || isBlockFirst}
                                        onFocus={(e) => e.target.select()}
                                        className="form-control neworder"
                                        style={{ width: '50%' }}
                                        value={prizes.sumRevenuePrize}
                                        type="number"
                                        onChange={(e) => onChangePrizes(e.target.value, 'sumRevenuePrize')}
                                    />
                                </div>
                            </div>
                        </div>
            
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={onClose}>Отмена</button>
                            <button type="button" onClick={onSubmit} disabled={!prizes.percent && !prizes.prizeRevenue && !prizes.sumRevenuePrize} className="btn btn-primary"> Сохранить </button>
                        </div>
                    </div>
                    </div>
                </div>
            </form>
        );
    }

    const renderHandlePrizesModal = () => {
        if (!modal || (modal.type !== 'handlePrizes' && modal.type !== 'handleDepremation')) return null;

        const onClose = () => { onCloseModal() }

        return (
            <form>
                <div  className="modal fade show" style={{ display: 'block' }}>
                    <div className="modal-dialog modal-lg modal-dialog-scrollable" style={{ height: '90%', alignItems: 'center', maxWidth: '90vw', justifyContent: 'center', width: 'fit-content' }}>
                    <div ref={modalRef} className="modal-content" style={{ height: '80%' }}>
                        <div className="modal-header">
                        <h5 className="modal-title"> {modal.type === 'handlePrizes' ? 'Премии' : 'Депремирования'} </h5>
                        <button onClick={onClose} type="button" className="close">
                        </button>
                        </div>
                        <div ref={modalRef} className="modal-body">
                        <PrizeTable
                            stylesTable={stylesTable}
                            staff={(staff && staff.length > 0) ? staff.filter((item) => !item.isDelete && !item.isDeleted) : null}
                            staffData={(data.revenuesStaff && data.revenuesStaff.length > 0) ? [...data.revenuesStaff] : null}
                            startOfMonthDate={data.revenue.startOfMonthDate}
                            isBlockFirst={isBlockFirst}
                            isBlockSecond={isBlockSecond}
                            onDeletePrize={onDeletePrize}
                            onAddPrize={onAddPrize}
                            onSavePrize={onSavePrize}
                            type={modal.type === 'handlePrizes' ? 'prize' : 'depremation'}
                        />
                        </div>
                    </div>
                    </div>
                </div>
            </form>
        );
    }

    const renderSettingsModal = () => {
        if (!modal || modal.type !== 'settings') return null;

        const onClose = () => {
            onCloseModal();
        }

        const onSubmit = () => {
            const updated = {...data};
            if (modal.revenueRatio !== updated.revenue.revenueRatio) {
                updated.revenue.revenueRatio = modal.revenueRatio
                updated.revenue.isChange = true;
            }

            if (modal.normalShift !== updated.revenue.normalShift) {
                updated.revenue.normalShift = modal.normalShift
                updated.revenue.isChange = true;
            }

            const percentsData = updated.revenue.percentsPosts || {};
            const percentsModal = modal.percentsPosts || {};
            (postsIds || []).forEach((post) => {
                const stringId = String(post.id);
                if (percentsData[stringId] !== percentsModal[stringId]) {
                    percentsData[stringId] = percentsModal[stringId];
                    updated.revenue.isChange = true;
                }
            });

            updated.revenue.percentsPosts = percentsData;
            setData(updated);
            onCloseModal();
        }

        const onChangeRevenueFields = (value, field) => {
            const updated = {...modal};
            updated[field] = value || 0;
            setModal(updated);
        }
    
        const onChangePercentsPosts = (value, post) => {
            const updated = {...modal};
            const percents = modal.percentsPosts || {};
            percents[post] = value;
            updated.percentsPosts = percents;
            setModal(updated);
        }

        return (
            <form>
                <div  className="modal fade show" style={{ display: 'block' }}>
                    <div className="modal-dialog modal-lg modal-dialog-scrollable" style={{ height: '90%', alignItems: 'center', justifyContent: 'center' }}>
                    <div ref={modalRef} className="modal-content" style={{ height: '80%' }}>
                        <div className="modal-header">
                        <h5 className="modal-title"> Настройки </h5>
                        <button onClick={onClose} type="button" className="close">
                        </button>
                        </div>
                        <div ref={modalRef} className="modal-body">
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <label style={{ color: '#000' }}>
                                        Коэффициент выручки %
                                    </label>
                                    <input
                                        disabled={[roleId.cashier].includes(user.role.id) || isBlockSecond || isBlockFirst}
                                        onFocus={(e) => e.target.select()}
                                        className="form-control neworder"
                                        style={{ width: '50%' }}
                                        value={modal.revenueRatio || 0}
                                        type="number"
                                        onChange={(e) => {
                                            let value = e.target.value;
                                            if (value < 0) value = 0;
                                            if (!value || value > 100) value = 100;
                                            onChangeRevenueFields(parseNumToFixed(value), 'revenueRatio');
                                        }}
                                    />
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <label style={{ color: '#000' }}>
                                        Полная смена (ч.)
                                    </label>
                                    <input
                                        disabled={[roleId.cashier, roleId.manager].includes(user.role.id) || isBlockSecond || isBlockFirst}
                                        onFocus={(e) => e.target.select()}
                                        className="form-control neworder"
                                        style={{ width: '50%' }}
                                        value={modal.normalShift || 13}
                                        type="number"
                                        onChange={(e) => {
                                            let value = e.target.value;
                                            if (!value || value < 0) value = 0;
                                            onChangeRevenueFields(parseNumToFixed(value), 'normalShift')
                                        }}
                                    />
                                </div>
                                {(postsIds || []).map((post) => (
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <label style={{ color: '#000' }}>
                                        % от выручки {post.moreLabel || post.label || '-'}
                                    </label>
                                    <input
                                        disabled={[roleId.cashier, roleId.manager].includes(user.role.id) || isBlockSecond || isBlockFirst}
                                        onFocus={(e) => e.target.select()}
                                        className="form-control neworder"
                                        style={{ width: '50%' }}
                                        value={(!isEmpty(modal.percentsPosts)) ? modal.percentsPosts[String(post.id)] || 0 : 0}
                                        type="number"
                                        onChange={(e) => {
                                            let value = e.target.value;
                                            if (!value || value < 0) value = 0;
                                            onChangePercentsPosts(parseNumToFixed(value), String(post.id))
                                        }}
                                    />
                                </div>
                                ))}
                            </div>
                        </div>
            
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={onClose}>Отмена</button>
                            <button type="button" className="btn btn-primary" onClick={onSubmit}> Сохранить </button>
                        </div>
                    </div>
                    </div>
                </div>
            </form>
        );
    }

    const renderUnusedStaffModal = () => {
        if (!modal || modal.type !== 'unused') return null;
        const { unusedStaff } = modal;

        const onSubmit = () => {
            const daysCount = moment(data.revenue.startOfMonthDate).daysInMonth();
            const dataMonth = Array.from({ length: daysCount }, () => ({ sum: { plan: null } }));
            const restoredStaffData = { ...newStaff, revenueId: data.revenue.id, firstRate: (newStaff.lastRate || 0), secondRate: (newStaff.lastRate || 0), isChange: true, isRestored: true, revenues: dataMonth, startOfMonthDate: data.revenue.startOfMonthDate };
            const updated = {...data};
            if (!isEmpty(updated.revenuesStaff)) {
                updated.revenuesStaff.push(restoredStaffData);
            } else {
                updated.revenuesStaff = [restoredStaffData];
            }
            setData(updated);
            onCloseModal();
        }

        const options = (unusedStaff || []).map((item) => ({
            staffId: item.id,
            value: item.id,
            lastRate: (item.lastRate && item.lastRate.sum) ? item.lastRate.sum : 0,
            lastPrizes: item.lastPrizes ? item.lastPrizes : 0,
            label: item.name,
            name: item.name,
        }))

        return (
            <form>
                <div  className="modal fade show" style={{ display: 'block' }}>
                    <div className="modal-dialog modal-lg modal-dialog-scrollable" style={{ height: '90%', alignItems: 'center', justifyContent: 'center' }}>
                    <div ref={modalRef} className="modal-content" style={{ height: '80%' }}>
                        <div className="modal-header">
                        <h5 className="modal-title"> Добавление существующего сотрудника </h5>
                        <button onClick={onCloseModal} type="button" className="close">
                        </button>
                        </div>
                        <div ref={modalRef} className="modal-body">
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            <Select
                                closeMenuOnSelect={true}
                                options={options}
                                placeholder="Сотрудник"
                                noOptionsMessage={() => 'Нет сотрудников'}
                                value={newStaff && newStaff.staffId ? options.find((p) => p.id === newStaff.staffId) : null}
                                onChange = {(e) => setNewStaff({ ...newStaff, staffId: e.staffId, lastRate: e.lastRate, lastPrizes: e.lastPrizes, name: e.name })}
                            />
                            </div>
                        </div>
            
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={onCloseModal}>Отмена</button>
                            <button type="button" onClick={onSubmit} disabled={!newStaff || !newStaff.staffId} className="btn btn-primary"> Сохранить </button>
                        </div>
                    </div>
                    </div>
                </div>
            </form>
        );
    }

    const renderHistory = () => {
        if (!modal || modal.type !== 'history') return null;

        const getRenderRevenueChanges = () => {
            if (!isEmpty(data) && !isEmpty(data.revenue) && !isEmpty(data.revenue.changeLog)) {
                return data.revenue.changeLog.map((change) => {
                    switch (change.field) {
                        case 'revenueRatio': {
                            if (change.type === 'edit') return {
                                date: change.date,
                                text: `Коэффициент выручки изменен с ${change.old || '-'} на ${change.new || '-'}. Автор: ${change.user || '-'}.`, 
                            };
    
                            return {
                                date: change.date,
                                text: `Добавлен коэффициент выручки значение: ${change.new || '-'}. Автор: ${change.user || '-'}.`, 
                            };
                        }
                        case 'normalShift': {
                            if (change.type === 'edit') return {
                                date: change.date,
                                text: `Полная смена изменена с ${change.old || '-'} на ${change.new || '-'}. Автор: ${change.user || '-'}.`, 
                            };
    
                            return {
                                date: change.date,
                                text: `Добавлена полная смена значение: ${change.new || '-'}. Автор: ${change.user || '-'}.`, 
                            };
                        }
                        case 'percentsPosts': {
                            let newText = [];
                            if (change.type === 'edit') {
                                let oldText = [];

                                Object.entries(change.old).forEach(([postId, oldData]) => {
                                    const post = postsIds.find((item) => item.id === parseInt(postId));
                                    const label = post ? post.moreLabel || post.label || '-' : '-';
                                    oldText.push(`${label}: ${oldData}%`)
                                });

                                Object.entries(change.new).forEach(([postId, newData]) => {
                                    const post = postsIds.find((item) => item.id === parseInt(postId));
                                    const label = post ? post.moreLabel || post.label || '-' : '-';
                                    newText.push(`${label}: ${newData}%`)
                                });
    

                                return {
                                    date: change.date,
                                    text: `Проценты от выручки изменены с ${oldText.join(', ') || '-'} на ${newText.join(', ') || '-'}. Автор: ${change.user || '-'}.`, 
                                };
                            }

                            Object.entries(change.new).forEach(([postId, newData]) => {
                                const post = postsIds.find((item) => item.id === parseInt(postId));
                                const label = post ? post.moreLabel || post.label || '-' : '-';
                                newText.push(`${label}: ${newData}%`)
                            });

                            return {
                                date: change.date,
                                text: `Добавлены проценты от выручки ${newText.join(', ') || '-'}. Автор: ${change.user || '-'}.`, 
                            };
                        }
                        case 'staff': {
                            if (change.type === 'delete') return {
                                date: change.date,
                                text: `Удален сотрудник ${change.name || '-'}. Автор: ${change.user || '-'}.`
                            }
    
                            if (change.type === 'add') return {
                                date: change.date,
                                text: `Добавлен сотрудник ${change.name || '-'}. Автор: ${change.user || '-'}.`
                            }

                            return null;
                        }
                        case 'plan':
                        case 'result': {
                            const changeDate = (data.revenue.startOfMonthDate && change.index) ? moment(data.revenue.startOfMonthDate).add(change.index, 'days').format('DD.MM.YYYY') : '-';

                            if (change.type === 'edit') return {
                                date: change.date,
                                text: `${change.field === 'plan' ? 'Изменен план' : 'Изменен факт'} выручки за ${changeDate} с ${change.old || 0} на ${change.new || 0}. Автор: ${change.user || '-'}.`
                            }
    
                            return {
                                date: change.date,
                                text: `${change.field === 'plan' ? 'Добавлен план' : 'Добавлен факт'} выручки за ${changeDate} значение: ${change.new || 0}. Автор: ${change.user || '-'}.`
                            }
                        }
                        default: return null;
                    }
                }).filter((change) => change && change.text);
            }
            return [];
        }

        const getRenderStaffChanges = () => {
            if (!isEmpty(data) && !isEmpty(data.revenuesStaff)) {
                return data.revenuesStaff.flatMap((item) => {
                    if (isEmpty(item) || isEmpty(item.changeLog)) return [];
                    const entity = staff.find((el) => el.id === item.staffId);
                    const name = (entity && entity.name) ? entity.name : item.name;
                    return item.changeLog.map((change) => {
                        if (change.type === 'restore') return {
                            date: change.date,
                            text: `Сотрудник ${name} восстановлен. Автор: ${change.user}.`,
                        }

                        switch (change.field) {
                            case 'plan':
                            case 'result': {
                                const changeDate = (data.revenue.startOfMonthDate && change.index) ? moment(data.revenue.startOfMonthDate).add(change.index, 'days').format('DD.MM.YYYY') : '-';
    
                                if (change.type === 'edit') return {
                                    date: change.date,
                                    text: `${change.field === 'plan' ? 'Изменен план' : 'Изменен факт'} сотруднику ${name} за ${changeDate} с ${change.old || 0} на ${change.new || 0}. Автор: ${change.user || '-'}.`
                                }
        
                                return {
                                    date: change.date,
                                    text: `${change.field === 'plan' ? 'Добавлен план' : 'Добавлен факт'} сотруднику ${name} за ${changeDate} значение: ${change.new || 0}. Автор: ${change.user || '-'}.`
                                }
                            }
                            case 'prize':
                            case 'depremation': {
                                if (change.type === 'edit') {
                                    if (!change.oldDateprize && !change.newDatePrize) {
                                        return {
                                            date: change.date,
                                            text: `${change.field === 'prize' ? 'Изменена премия' : 'Изменено депремирование'} сотруднику ${name} за ${moment(change.datePrize).format('DD.MM.YYYY')} с ${change.old || 0} на ${change.new || 0}. Автор: ${change.user || '-'}.`
                                        }
                                    } else {
                                        return {
                                            date: change.date,
                                            text: `${change.field === 'prize' ? 'Изменена дата премии' : 'Изменена дата депремирования'} сотруднику ${name} с ${moment(change.oldDatePrize).format('DD.MM.YYYY')} на ${moment(change.newDatePrize).format('DD.MM.YYYY')}. Автор: ${change.user || '-'}.`
                                        }
                                    }
                                }
    
                                if (change.type === 'add') return {
                                    date: change.date,
                                    text: `${change.field === 'prize' ? 'Добавлена премия' : 'Добавлено депремирование'} сотруднику ${name} за ${moment(change.datePrize).format('DD.MM.YYYY')} значение: ${change.new || 0}. Автор: ${change.user || '-'}.`
                                }
    
                                if (change.type === 'delete') return {
                                    date: change.date,
                                    text: `${change.field === 'prize' ? 'Удалена премия' : 'Удалено депремирование'} сотруднику ${name} за ${moment(change.datePrize).format('DD.MM.YYYY')}. Автор: ${change.user || '-'}.`
                                }
    
                                if (change.type === 'send') {
                                    const entityNew = change.staffId ? staff.find((el) => el.id === change.staffId) : null;
                                    const newStaffName = (entityNew && entityNew.name) ? entityNew.name : null;
    
                                    return {
                                        date: change.date,
                                        text: `${change.field === 'prize' ? 'Переназначена премия' : 'Переназначено депремирование'} от сотрудника ${name} сотруднику ${newStaffName || '-'} за ${moment(change.datePrize).format('DD.MM.YYYY')} сумма ${change.new || 0}. Автор: ${change.user || '-'}.`
                                    }
                                }
    
                                if (change.type === 'take') return {
                                    date: change.date,
                                    text: `${change.field === 'prize' ? 'Назначена премия' : 'Назначено депремирование'} сотруднику ${name} за ${moment(change.datePrize).format('DD.MM.YYYY')} сумма ${change.new || 0}. Автор: ${change.user || '-'}.`
                                }
                                
                                return null;
                            }
                            case 'firstRate':
                            case 'secondRate': {
                                if (change.type === 'edit') return {
                                    date: change.date,
                                    text: `Изменена ставка за период ${change.field === 'firstRate' ? '1-15' : '16-31'} сотруднику ${name} с ${change.old || 0} на ${change.new || 0}. Автор: ${change.user || '-'}.`
                                }
    
                                return {
                                    date: change.date,
                                    text: `Добавлена ставка за период ${change.field === 'firstRate' ? '1-15' : '16-31'} сотруднику ${name} значение ${change.new || 0}. Автор: ${change.user || '-'}.`
                                }
                            }
                            case 'pendingFirstRate':
                            case 'pendingSecondRate': {
                                if (change.type === 'edit') return {
                                    date: change.date,
                                    text: `Изменен запрос ставки за период ${change.field === 'pendingFirstRate' ? '1-15' : '16-31'} сотруднику ${name} с ${change.old || 0} на ${change.new || 0}. Автор: ${change.user || '-'}.`
                                }
    
                                return {
                                    date: change.date,
                                    text: `Добавлен запрос ставки за период ${change.field === 'pendingFirstRate' ? '1-15' : '16-31'} сотруднику ${name} значение ${change.new || 0}. Автор: ${change.user || '-'}.`
                                }
                            }
                            case 'name': {
                                if (change.type === 'edit') return {
                                    date: change.date,
                                    text: `Изменено ФИО сотруднику ${name} с ${change.old || '-'} на ${change.new || '-'}. Автор: ${change.user || '-'}.`
                                }
    
                                return {
                                    date: change.date,
                                    text: `Добавлено ФИО сотруднику ${name} значение ${change.new || '-'}. Автор: ${change.user || '-'}.`
                                }
                            }
                            case 'firstPrizeRevenue':
                            case 'secondPrizeRevenue': {
                                if (change.type === 'edit') return {
                                    date: change.date,
                                    text: `Изменена премия от выручки за период ${change.field === 'firstPrizeRevenue' ? '1-15' : '16-31'} сотруднику ${name} с ${change.old || 0} на ${change.new || 0}. Автор: ${change.user || '-'}.`
                                }
    
                                return {
                                    date: change.date,
                                    text: `Добавлена премия от выручки за период ${change.field === 'firstPrizeRevenue' ? '1-15' : '16-31'} сотруднику ${name} значение ${change.new || 0}. Автор: ${change.user || '-'}.`
                                }
                            }
                            case 'firstSumRevenuePrize':
                            case 'secondSumRevenuePrize': {
                                if (change.type === 'edit') return {
                                    date: change.date,
                                    text: `Изменена сумма выручки для премирования за период ${change.field === 'firstSumRevenuePrize' ? '1-15' : '16-31'} сотруднику ${name} с ${change.old || 0} на ${change.new || 0}. Автор: ${change.user || '-'}.`
                                }
    
                                return {
                                    date: change.date,
                                    text: `Добавлена сумма выручки для премирования за период ${change.field === 'firstSumRevenuePrize' ? '1-15' : '16-31'} сотруднику ${name} значение ${change.new || 0}. Автор: ${change.user || '-'}.`
                                }
                            }
                            default: return null;
                        }
                    }).filter((change) => change && change.text);
                })
            }
            return [];
        }

        const renderRevenueChanges = getRenderRevenueChanges() || [];
        const renderStaffChanges = getRenderStaffChanges() || [];        
        
        const changes = [...renderRevenueChanges, ...renderStaffChanges];
        const groupedData = new Map();

        changes.forEach(item => {
            const fullDate = item.date;
            if (!groupedData.has(fullDate)) {
                groupedData.set(fullDate, []);
            }
            groupedData.get(fullDate).push(item);
        });

        const sortedData = Array.from(groupedData.entries())
        .sort((a, b) => {
            const momentA = moment(a[0], 'DD.MM.YYYY HH:mm:ss');
            const momentB = moment(b[0], 'DD.MM.YYYY HH:mm:ss');
            return momentB - momentA;
        })
        .map(([date, items]) => ({ date, items }));

        const renderBody = () => {
        if (isEmpty(sortedData)) return <div ref={modalRef} className="modal-body"> Нет данных об изменениях </div>

        return (
            <div ref={modalRef} className="modal-body" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {sortedData.map((item) => (
                    <div style={{ borderBottom: '1px solid #000'}}>
                        <h6 style={{ color: '#000', fontWeight: 600 }}>{item.date}</h6>
                        {item.items.map((change) => (
                            <div>
                                <span style={{ color: '#000' }}>
                                    {change.text || '-'}
                                </span>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        )
        }
        
        return (
            <form>
                <div className="modal fade show" style={{ display: 'block' }}>
                    <div className="modal-dialog modal-lg modal-dialog-scrollable" style={{ height: '90%', alignItems: 'center', justifyContent: 'center' }}>
                    <div ref={modalRef} className="modal-content">
                        <div className="modal-header">
                        <h5 className="modal-title"> История изменений </h5>
                        <button onClick={onCloseModal} type="button" className="close" />
                        </div>
                        {renderBody()}
                    </div>
                    </div>
                </div>
            </form>
        );
    }

    const renderChoiceRenderRevenue = () => {
        if (!modal || modal.type !== 'choiceRenderRevenue') return null;

        const onSubmit = (value) => {
            setRenderRevenueStaff(value);
            onCloseModal();
        }

        return (
            <form>
                <div className="modal fade show" style={{ display: 'block' }}>
                    <div className="modal-dialog modal-lg modal-dialog-scrollable" style={{ height: '90%', alignItems: 'center', justifyContent: 'center', maxWidth: '500px', width: 'fit-content' }}>
                    <div ref={modalRef} className="modal-content">
                        <div className="modal-header">
                        <h5 className="modal-title"> Пересчет часов сотрудников </h5>
                        <button onClick={onCloseModal} type="button" className="close">
                        </button>
                        </div>
                        <div ref={modalRef} className="modal-body">
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <button type="button" className="btn btn-secondary" onClick={onCloseModal}>Отмена</button>
                                <button type="button" className='btn btn-sm btn-primary' onClick={() => onSubmit('sum')}> Оклад </button>
                                <button type="button" className='btn btn-sm btn-primary' onClick={() => onSubmit('prizeSum')}> Премия </button>
                                <button type="button" className='btn btn-sm btn-primary' onClick={() => onSubmit('fullSum')}> Оклад + премия </button>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </form>
        );
    }

    const renderChoiceModal = () => {
        if (!modal || modal.type !== 'choice') return null;
        const { postId, unusedStaff } = modal;

        return (
            <form>
                <div className="modal fade show" style={{ display: 'block' }}>
                    <div className="modal-dialog modal-lg modal-dialog-scrollable" style={{ height: '90%', alignItems: 'center', justifyContent: 'center', maxWidth: '500px', width: 'fit-content' }}>
                    <div ref={modalRef} className="modal-content">
                        <div className="modal-header">
                        <h5 className="modal-title"> Добавление сотрудника </h5>
                        <button onClick={onCloseModal} type="button" className="close">
                        </button>
                        </div>
                        <div ref={modalRef} className="modal-body">
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <button type="button" className="btn btn-secondary" onClick={onCloseModal}>Отмена</button>
                                <button type="button" className='btn btn-sm btn-primary' onClick={() => openAddStaffModal(postId, 'unused', unusedStaff)}> Существующий сотрудник </button>
                                <button type="button" className='btn btn-sm btn-primary' onClick={() => openAddStaffModal(postId, 'new')}> Новый сотрудник </button>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </form>
        );
    }

    const renderPostChoiceModal = () => {
        if (!modal || modal.type !== 'postChoice') return null;
        const { post } = modal;

        const onSubmit = () => {
            const postStaff = (data.revenuesStaff && data.revenuesStaff.length > 0) ? data.revenuesStaff.map((item, index) => ({ ...item, index })).filter((item) => item.postId === post.value && !item.isDelete && !item.isDeleted) : null;
            addStaff(post.value, postStaff);
        }

        return (
            <form>
                <div className="modal fade show" style={{ display: 'block' }}>
                    <div className="modal-dialog modal-lg modal-dialog-scrollable" style={{ height: '90%', alignItems: 'center', justifyContent: 'center', maxWidth: '500px', width: 'fit-content' }}>
                    <div ref={modalRef} className="modal-content">
                        <div className="modal-header">
                        <h5 className="modal-title"> Выбор должности сотрудника </h5>
                        <button onClick={onCloseModal} type="button" className="close">
                        </button>
                        </div>
                        <div ref={modalRef} className="modal-body">
                            <Select
                                closeMenuOnSelect={true}
                                options={postsIds.map((item) => ({ value: item.id, label: item.label }))}
                                placeholder="Должность"
                                noOptionsMessage={() => 'Нет должностей'}
                                value={post}
                                onChange = {(e) => setModal({ ...modal, post: e})}
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={onCloseModal}>Отмена</button>
                            <button disabled={!post || !post.value} type="button" onClick={onSubmit} className="btn btn-primary"> Далее </button>
                        </div>
                    </div>
                    </div>
                </div>
            </form>
        );
    }

    const renderPeriod = () => {
        if (!modal || modal.type !== 'period') return null;

        const onChangeDate = (field) => (date) => {
            setPeriod({ ...period, [field]: { ...period[field], date: date }});
        }

        const onSubmit = () => {
            if (!period.start.date && !period.end.date) setPeriod({ start: { date: null, index: null }, end: { date: null, index: null } });
            
            const startDate = moment(data.revenue.startOfMonthDate);

            if (period.start.date && period.end.date) {
                const startIndex = moment(period.start.date).diff(moment(startDate).set({ hour: 0, minute: 0, second: 0 }), 'days');
                const endIndex = moment(period.end.date).endOf('day').diff(startDate, 'days');
                setPeriod({ start: { ...period.start, index: startIndex }, end: { ...period.end, index: endIndex } });
            } else {
                if (period.start.date) {
                    const startIndex = moment(period.start.date).diff(moment(startDate).set({ hour: 0, minute: 0, second: 0 }), 'days');
                    setPeriod({ start: { ...period.start, index: startIndex }, end: { date: null, index: null } });
                }
                
                if (period.end.date) {
                    const endIndex = moment(period.end.date).endOf('day').diff(startDate, 'days');
                    setPeriod({ start: { date: null, index: null }, end: { ...period.end, index: endIndex } });
                }
            }
            
            onCloseModal();
        }

        return (
            <form>
                <div className="modal fade show" style={{ display: 'block' }}>
                    <div className="modal-dialog modal-lg modal-dialog-scrollable" style={{ height: '90%', alignItems: 'center', justifyContent: 'center', maxWidth: '500px', width: 'fit-content' }}>
                    <div ref={modalRef} className="modal-content">
                        <div className="modal-header">
                        <h5 className="modal-title"> Выбор периода </h5>
                        <button onClick={onCloseModal} type="button" className="close">
                        </button>
                        </div>
                        <div ref={modalRef} className="modal-body">
                            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                <DateInput
                                    placeholderText="Начало периода"
                                    selected={period.start.date}
                                    onChange={onChangeDate('start')}
                                    maxDate={period.end.date ? period.end.date : moment(data.revenue.startOfMonthDate).endOf('month').toDate()}
                                    minDate={moment(data.revenue.startOfMonthDate).toDate()}
                                    showTimeSelect={false}
                                    portalId="modal-picker"
                                    isClearable
                                />
                                -
                                <DateInput
                                    placeholderText="Конец периода"
                                    selected={period.end.date}
                                    onChange={onChangeDate('end')}
                                    maxDate={moment(data.revenue.startOfMonthDate).endOf('month').toDate()}
                                    minDate={period.start.date ? period.start.date : moment(data.revenue.startOfMonthDate).toDate()}
                                    showTimeSelect={false}
                                    portalId="modal-picker"
                                    isClearable
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={onCloseModal}>Отмена</button>
                            <button type="button" onClick={onSubmit} className="btn btn-primary"> Сохранить </button>
                        </div>
                    </div>
                    </div>
                </div>
            </form>
        );
    }

    const openModal = (type, modalData) => {
        if (!modalData) return setModal({ type });
        return setModal({ type, ...modalData});
    }

    const openAddStaffModal = (postId, type, unusedStaff) => {
        setNewStaff({ postId, pointId: data.revenue.pointId, lastRate: 0, name: null });
        setModal({ type, postId, unusedStaff });
    };

    const renderModal = () => {
        if (modal && !isEmpty(modal)) {
            let render = null;
            switch (modal.type) {
                case 'new': {
                    render = renderNewStaffModal;
                    break;
                }
                case 'unused': {
                    render = renderUnusedStaffModal;
                    break;
                }
                case 'choice': {
                    render = renderChoiceModal;
                    break;
                }
                case 'postChoice': {
                    render = renderPostChoiceModal;
                    break;
                }
                case 'settings': {
                    render = renderSettingsModal;
                    break;
                }
                case 'history': {
                    render = renderHistory;
                    break;
                }
                case 'period': {
                    render = renderPeriod;
                    break;
                }
                case 'prizes': {
                    render = renderPrizesModal;
                    break;
                }
                case 'handleDepremation':
                case 'handlePrizes': {
                    render = renderHandlePrizesModal;
                    break;
                }
                case 'choiceRenderRevenue': {
                    render = renderChoiceRenderRevenue;
                    break;
                }
                default: {
                    break;
                }
            }
            if (render) {
                return (
                    <>
                        {render()}
                        <div className="modal-backdrop fade show" />
                    </>
                );
            }
        }
        return;
    }

    const addStaff = (postId, postStaff) => {
        const unusedStaff = (staff || []).filter((item) => {
            if (item.postId !== postId) return false;
            if (!isEmpty(postStaff) && postStaff.length > 0 && postStaff.find((el) => el.staffId === item.id)) return false;
            return true;
        });
        
        if (unusedStaff && unusedStaff.length > 0) return openModal('choice', { postId, unusedStaff});
        return openAddStaffModal(postId, 'new');
    }

    const isPeriod = !isNotNumber(period.start.index) && !isNotNumber(period.end.index);

    const renderPostData = (post) => {
        if (!post || !post.id || (!post.label && !post.moreLabel)) return;
        const staff = (data.revenuesStaff && data.revenuesStaff.length > 0) ? [...data.revenuesStaff] : null;
        const postStaff = (staff && staff.length > 0)
        ? staff
            .map((item, index) => ({ ...item, index }))
            .filter((item) => item.postId === post.id && !item.isDelete && !item.isDeleted)
            .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
        : null;
        if (isEmpty(postStaff)) return;

        const revenueCells = Array.from({ length: columnsCount }, (_, index) => {
            if (period.start.index && index < period.start.index) return null;
            if (period.end.index && index > period.end.index) return null;

            const start = period.start.index || 0;
            let end;
            if (!isNotNumber(period.end.index)) {
                end = period.end.index;
            } else {
                const monthStart = (!isEmpty(data) && !isEmpty(data.revenue) && !isEmpty(data.revenue.startOfMonthDate)) ? moment(data.revenue.startOfMonthDate) : null;
                const daysInMonth = monthStart ? monthStart.daysInMonth() : 30;
                end = daysInMonth - 1;
            }

            let firstMid, secondMid;

            const endFirst = Math.min(end, 14);
            if (start <= 14 && endFirst >= start) firstMid = Math.floor((start + endFirst) / 2);

            const startSecond = Math.max(start, 15);
            if (end >= 15 && startSecond <= end) secondMid = Math.floor((startSecond + end) / 2);
            
            if ((!isNotNumber(firstMid) && index === firstMid) || (!isNotNumber(secondMid) && index === secondMid)) {
                return (
                    <td style={{ ...stylesTable.sm, overflow: 'visible', textWrap: 'nowrap' }} className="kt-datatable__cell">
                        <span style={{ color: '#000', width: '55px', overflow: 'visible', textWrap: 'nowrap', padding: '0px', paddingLeft: '40px' }}> {post.moreLabel || post.label} </span>
                    </td>
                );
            }

            const startFirstIndex = period.start.index || 0;
            const startSecondIndex = period.end.index || 15;

            if (index === startFirstIndex || index === startSecondIndex) {
            return (
                <td style={{ ...stylesTable.sm }} className="kt-datatable__cell">
                    {(!isEmpty(postStaff) && postStaff.length > 0 && [roleId.admin, roleId.operationDirector, roleId.regionalDirector].includes(user.role.id)) && 
                        <button title='Изменение премии от выручки' className="btn btn-sm btn-icon btn-success" style={{ width: '2rem', height: '2rem' }} onClick={() => openModal('prizes', { post: { id: post.id, label: post.label }, period: index === 0 ? 'first' : 'second'})}>
                            <i className="kt-nav__link-icon flaticon2-contract" />
                        </button>
                    }
                </td>
            );
            } else if (index !== 14 || (index === 14 && period.end.index === 14)) {
                return (
                    <td style={{ ...stylesTable.sm }} className="kt-datatable__cell" />
                );
            }
          
            return (
                 <>
                    <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell" />
                    <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                        Часов
                    </td>
                    {user.role.id !== roleId.cashier && <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                        Сумма руб.
                    </td>}
                    <td style={{ ...stylesTable.lg, ...stylesTable.textStart, ...stylesTable.borderLeft, overflow: 'visible', ...(user.role.id !== roleId.cashier ? {} : stylesTable.borderRight), position: 'relative' }} className="kt-datatable__cell">
                        Сотрудник
                        {user.role.id !== roleId.cashier && (
                        <button onClick={() => setOpenPrizesColumns(!openPrizesColumns)} style={{ backgroundColor: '#fff', width: '12px', height: '12px', lineHeight: '12px', position: 'absolute', right: '-6px', top: '50%', transform: 'translateY(-50%)', border: 'none', cursor: 'pointer', padding: 0, fontSize: '12px', borderRadius: '2px' }}>
                            {openPrizesColumns ? '-' : '+'}
                        </button>
                        )}
                    </td>
                    {user.role.id !== roleId.cashier && 
                    <>
                    <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft, ...stylesTable.borderRight }} className="kt-datatable__cell">
                        Ставка
                    </td>
                    {openPrizesColumns &&
                        <>
                        <td style={{ ...stylesTable.md, ...stylesTable.borderLeft, ...stylesTable.borderRight }} className="kt-datatable__cell">
                            Премия от выручки
                        </td>
                        <td style={{ ...stylesTable.md, ...stylesTable.borderLeft, ...stylesTable.borderRight }} className="kt-datatable__cell">
                            Сумм. выр. для прем.
                        </td>
                        </>
                    }
                    </>
                    }
                 </>
            );
        });

        return (
            <>
            <tr style={{ backgroundColor: '#CCCCCC', ...stylesTable.outline}} className="kt-datatable__row">
                <td style={{ ...stylesTable.lg, ...stylesTable.textStart, ...stylesTable.borderLeft, overflow: 'visible', ...(user.role.id !== roleId.cashier ? {} : stylesTable.borderRight), position: 'relative' }} className="kt-datatable__cell">
                        Сотрудник
                        {user.role.id !== roleId.cashier && (
                        <button onClick={() => setOpenPrizesColumns(!openPrizesColumns)} style={{ backgroundColor: '#fff', width: '12px', height: '12px', lineHeight: '12px', position: 'absolute', right: '-6px', top: '50%', transform: 'translateY(-50%)', border: 'none', cursor: 'pointer', padding: 0, fontSize: '12px', borderRadius: '2px' }}>
                            {openPrizesColumns ? '-' : '+'}
                        </button>
                        )}
                </td>
                {user.role.id !== roleId.cashier && 
                <>
                <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft, ...stylesTable.borderRight }} className="kt-datatable__cell">
                    Ставка
                </td>
                {openPrizesColumns && 
                    <>
                    <td style={{ ...stylesTable.md, ...stylesTable.borderLeft, ...stylesTable.borderRight }} className="kt-datatable__cell">
                        Премия от выручки
                    </td>
                    <td style={{ ...stylesTable.md, ...stylesTable.borderLeft, ...stylesTable.borderRight }} className="kt-datatable__cell">
                        Сумм. выр. для прем.
                    </td>
                    </>
                }
                </>
                }
                {revenueCells}
                <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                    Часов
                </td>
                {user.role.id !== roleId.cashier &&  <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                    Сумма руб.
                </td>}
                <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft, fontSize: `${isPeriod ? '0.8rem' : '0.9rem'}` }} className="kt-datatable__cell">
                    {isPeriod ? 'Ч. за период' : 'Ч. за месяц'}
                </td>
                {user.role.id !== roleId.cashier && <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                    {isPeriod ? 'Итого за период' : 'Итого за месяц'} (р.)
                </td>}
            </tr>
            {postStaff && postStaff.length > 0 && postStaff.map((item) => (
                <React.Fragment key={item.id}>
                    {renderStaffData(item, postStaff)}
                </React.Fragment>
            ))}
            </>
        );
    }

    const renderBody = () => {
        if (!data || isEmpty(data.revenue)) return <div className='kt-portlet'> 
            <div className='kt-portlet__body'>Нет данных</div> 
        </div>

        return (
            <>
            <div className='kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded' style={{ width: 'max-content', overflow: 'auto' }}>
                <table className='kt-datatable__table' style={{ tableLayout: 'fixed', width: '100%' }}>
                    <tbody className='kt-datatable__body' style={{ padding: '5px' }}>
                        <tr style={stylesTable.outline} className="kt-datatable__row">
                            <td style={{ ...stylesTable.lg, ...stylesTable.textStart }} className="kt-datatable__cell">
                                {dateTitle}
                            </td>
                            {user.role.id !== roleId.cashier && 
                            <>
                            <td style={stylesTable.sm} className="kt-datatable__cell" />
                            {openPrizesColumns &&
                                <>
                                <td style={stylesTable.md} className="kt-datatable__cell" />
                                <td style={stylesTable.md} className="kt-datatable__cell" />
                                </>
                            }
                            </>
                            }
                            {renderDateCells()}
                            <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                                Итого
                            </td>
                            {user.role.id !== roleId.cashier && <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                                Итого
                            </td>}
                            <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                                {isPeriod ? 'За период' : 'За месяц'}
                            </td>
                            {user.role.id !== roleId.cashier && <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                                {isPeriod ? 'Итого за период' : 'Итого за месяц'}
                            </td>}
                        </tr>
                        <tr style={stylesTable.outline} className="kt-datatable__row">
                            <td style={{ ...stylesTable.lg, ...stylesTable.textStart }} className="kt-datatable__cell">
                                День недели
                            </td>
                            {user.role.id !== roleId.cashier && 
                            <>
                            <td style={stylesTable.sm} className="kt-datatable__cell" />
                            {openPrizesColumns &&
                                <>
                                <td style={stylesTable.md} className="kt-datatable__cell" />
                                <td style={stylesTable.md} className="kt-datatable__cell" />
                                </>
                            }
                            </>
                            }
                            {renderDayCells()}
                            <td style={stylesTable.sm} className="kt-datatable__cell" />
                            {user.role.id !== roleId.cashier && <td style={stylesTable.md} className="kt-datatable__cell" />}
                            <td style={stylesTable.sm} className="kt-datatable__cell" />
                            {user.role.id !== roleId.cashier && <td style={stylesTable.md} className="kt-datatable__cell" />}
                        </tr>
                        {user.role.id !== roleId.cashier && 
                        <>
                        <tr style={stylesTable.outline} className="kt-datatable__row">
                            <td style={{ ...stylesTable.lg, ...stylesTable.textStart }} className="kt-datatable__cell">
                                Выручка план (руб.)
                            </td>
                            {user.role.id !== roleId.cashier && 
                            <>
                            <td style={stylesTable.sm} className="kt-datatable__cell" />
                            {openPrizesColumns &&
                                <>
                                <td style={stylesTable.md} className="kt-datatable__cell" />
                                <td style={stylesTable.md} className="kt-datatable__cell" />
                                </>
                            }
                            </>
                            }
                            {renderRevenueCells('plan')}
                            <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell" />
                            {user.role.id !== roleId.cashier && <td style={{ ...stylesTable.md, ...stylesTable.borderLeft, ...stylesTable.borderRight }} className="kt-datatable__cell">
                                {formatNumberWithSpaces(roundToFixed(totalData.second.plan || 0, 0))}
                            </td>}
                            <td style={stylesTable.sm} className="kt-datatable__cell" />
                            {user.role.id !== roleId.cashier && <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                                {formatNumberWithSpaces(roundToFixed(totalData.total.plan || 0, 0))}
                            </td>}
                        </tr>
                        <tr style={stylesTable.outline} className="kt-datatable__row">
                            <td style={{ ...stylesTable.lg, ...stylesTable.textStart }} className="kt-datatable__cell">
                                Выручка факт (руб.)
                            </td>
                            {user.role.id !== roleId.cashier && 
                            <>
                            <td style={stylesTable.sm} className="kt-datatable__cell" />
                            {openPrizesColumns &&
                                <>
                                <td style={stylesTable.md} className="kt-datatable__cell" />
                                <td style={stylesTable.md} className="kt-datatable__cell" />
                                </>
                            }
                            </>
                            }
                            {renderRevenueCells('result')}
                            <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell" />
                            {user.role.id !== roleId.cashier && <td style={{ ...stylesTable.md, ...stylesTable.borderLeft, ...stylesTable.borderRight, backgroundColor: totalData.second.color }} className="kt-datatable__cell">
                                {formatNumberWithSpaces(roundToFixed(totalData.second.result || 0, 0))}
                            </td>}
                            <td style={stylesTable.sm} className="kt-datatable__cell" />
                            {user.role.id !== roleId.cashier && <td style={{ ...stylesTable.md, ...stylesTable.borderLeft, backgroundColor: totalData.total.color }} className="kt-datatable__cell">
                                {formatNumberWithSpaces(roundToFixed(totalData.total.result || 0, 0))}
                            </td>}
                        </tr>
                        </>
                        }
                        <tr style={stylesTable.outline} className="kt-datatable__row">
                            <td style={{ ...stylesTable.lg, ...stylesTable.textStart }} className="kt-datatable__cell">
                                Процент выполнения плана
                            </td>
                            {user.role.id !== roleId.cashier && 
                            <>
                            <td style={stylesTable.sm} className="kt-datatable__cell" />
                            {openPrizesColumns &&
                                <>
                                <td style={stylesTable.md} className="kt-datatable__cell" />
                                <td style={stylesTable.md} className="kt-datatable__cell" />
                                </>
                            }
                            </>
                            }
                            {renderPercentCells()}
                            <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                                {formatNumberWithSpaces(calculatePercent(totalData.second.result, totalData.second.plan))}%
                            </td>
                            {user.role.id !== roleId.cashier && <td style={{ ...stylesTable.md, ...stylesTable.borderLeft, ...stylesTable.borderRight }} className="kt-datatable__cell"/>}
                            <td style={{ ...stylesTable.sm, ...stylesTable.borderLeft }} className="kt-datatable__cell">
                                {formatNumberWithSpaces(calculatePercent(totalData.total.result, totalData.total.plan))}%
                            </td>
                            {user.role.id !== roleId.cashier && <td style={{ ...stylesTable.md, ...stylesTable.borderLeft }} className="kt-datatable__cell" />}
                        </tr>
                        {postsIds.map((post) => renderPostData(post))}
                    </tbody>
                    <colgroup>
                        {colWidths.map((w, idx) => <col key={idx} style={{ width: w }} />)}
                    </colgroup>
                </table>
            </div>
            </>
        );
    }

    return (
        <>
            {renderSubHeader()}
            <div className="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid" style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
                <div ref={containerRef} style={{ flex: '1 1 auto', overflowX: 'auto', overflowY: 'auto', minHeight: 0 }}>
                    <div style={{ position: 'sticky', left: 0, zIndex: 10, backgroundColor: '#fff' }}>
                        {renderButtonsHead()}
                    </div>
                    <div className="kt-portlet" style={{ width: 'max-content', overflow: 'visible' }}>
                        <div className="kt-portlet__body kt-portlet__body--fit">
                            {renderBody()}
                        </div>
                        <ErrorContainer field="wageFund" style={{ margin: '0 20px 20px' }} hasCloseButton={true} />
                        {user.role.id !== roleId.cashier && 
                        <>
                        <ResultTable
                            period={period}
                            weekendsDaysIndexes={weekendsDaysIndexes}
                            openPrizesColumns={openPrizesColumns}
                            stylesTable={stylesTable}
                            staffData={(data.revenuesStaff && data.revenuesStaff.length > 0) ? [...data.revenuesStaff] : null}
                            dataRevenues={data.revenue.revenues}
                            percentsPosts={(!isEmpty(data.revenue) && !isEmpty(data.revenue.percentsPosts)) ? data.revenue.percentsPosts || {} : {}}
                            revenueRatio={data.revenue.revenueRatio}
                            colWidths={colWidths}
                            columnsCount={columnsCount}
                            startOfMonthDate={data.revenue.startOfMonthDate}
                            normalShift={data.revenue.normalShift || 13}
                            calculateTotal={calculateTotal}
                            isNotNumber={isNotNumber}
                            getPrizeRevenueStaff={getPrizeRevenueStaff}
                            getPercentStaff={getPercentStaff}
                        />
                        {/* <PrizeRevenueTable
                            period={period}
                            weekendsDaysIndexes={weekendsDaysIndexes}
                            openPrizesColumns={openPrizesColumns}
                            stylesTable={stylesTable}
                            staffData={(data.revenuesStaff && data.revenuesStaff.length > 0) ? [...data.revenuesStaff] : null}
                            dataRevenues={data.revenue.revenues}
                            normalShift={!isEmpty(data.revenue) ? data.revenue.normalShift || 13 : 13}
                            percentsPosts={(!isEmpty(data.revenue) && !isEmpty(data.revenue.percentsPosts)) ? data.revenue.percentsPosts || {} : {}}
                            revenueRatio={data.revenue.revenueRatio}
                            colWidths={colWidths}
                            columnsCount={columnsCount}
                            entityStaffs={staff}
                            isNotNumber={isNotNumber}
                        /> */}
                        </>
                        }
                    </div>
                </div>
                {getIsChangedData() && (
                    <button className="btn btn-lg btn-primary" style={{ position: 'fixed', right: '50px', bottom: '30px' }} onClick={onSave}>
                        Сохранить
                    </button>
                )}
            </div>
            {renderModal()}
            <ContextMenu ref={contextMenuRef} />
        </>
    );
}

export default withRouter(WageFundTable);